import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import UploadIcon from "@mui/icons-material/Upload";
import {
  Button,
  CircularProgress,
  IconButton,
  Stack,
  CardContent,
  Card,
  Grid,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Alert,
  Switch,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { format } from "date-fns";
import { toast } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  default as ImageUploading,
  default as ReactImageUploading,
} from "react-images-uploading";
import { connect, shallowEqual, useSelector } from "react-redux";
import "react-responsive-modal/styles.css";
import countryList from "react-select-country-list";
import {
  getUserId,
  setBookingUserIdImages,
  moveUserIdImages,
} from "../../BookingDashboard/apis/BrandingModalApi";
import {
  getAllCustomers,
  imageUpdateByEmail,
} from "../../FlexibleSlot/api/FlexibleSlotApi";
import {
  addEditGuestUser,
  removeCustomerBooking,
  setIshaGuestConfig,
  setRoomPrimary,
  updateGuestCount,
  updatePrimaryGuest,
} from "../../Promocodes/apis/PromocodeApi";
import { saveAs } from "file-saver";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../../api";
import { getGeoCodeDetails } from "../../CalendarPage/api/ReservationApi";
import Webcam from "react-webcam";
import {
  addNewDoNotRentStatus,
  removeNewDoNotRentStatus,
} from "../../CalendarPage/api/BookingAndCustomerNotesApi";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  checkIshaAccess,
  checkIshaUSAccess,
  dateFnsFormat,
  getApprovedByOverseas,
  getCountriesAndStates,
  getGenderList,
  getIshaGenderList,
  getIshaProgramsAttended,
  getIshaPurposeOfVisit,
  getIshaRelationWithPrimary,
  getNationalityList,
  maxCompressMBSize,
  validateEmail,
  validatePhoneNumber,
} from "../../CalendarPage/constants/Calendar-constants";
import moment from "moment";
import imageCompression from "browser-image-compression";
import { getAllChangedPrice } from "./EditAdultChildrenApi";
import { useTranslation } from "react-i18next"; // Import useTranslation hook
import i18n from "../../../modules/Auth/pages/i18n";
import IDguru from "../../IDguru/IDguru";
import { isNull, isUndefined } from "lodash";
import { getAllCTA } from "../../CTA/apis/CTAApi";
import axios from "axios";
import { AI_SCANNERS } from "../../../Utils/CONST";
import { useAmbirScanWebConnect } from "../../../Utils/ambirScanWebConnect/useAmbirScanWebConnect";
import ScannerPickerDialog from "../../../Utils/ambirScanWebConnect/ScannerPickerDialog";
import { parseDateOfBirth } from "../../../Utils/ambirScanWebConnect/aamva";

function GuestInformation({
  onCancelClick,
  bookingId,
  datas,
  guestDataList,
  // roomIdList,
  // UserImagesData,
  data,
  emailId,
  ishaGuestData,
  hotelType,
  updateData,
  customerNotes,
  getCustomerNotes,
  reservationIds,
  reservationInfoData,
  allGuestsList,
  resCurrentConfig,
  selectedGuestStatus,
  updateInvoice,
  balanceDue,
  selectedUserResId,
  invoiceData,
  selectedLanguage,
  primaryGuestId,
}) {
  const { t } = useTranslation();
  const [CTAData, setCTAData] = useState([]);

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);
  const ishaProgramsAttended = getIshaProgramsAttended();
  const ishaRelationWithPrimary = getIshaRelationWithPrimary();
  const ishaApprovedByOverseas = getApprovedByOverseas();
  const nationalities = getNationalityList();
  const genderList = getGenderList();
  /* Getting the customer information fields */
  // customer name
  const [custName, setCustName] = useState("");
  const [custId, setCustId] = useState();
  const [custContact, setCustContact] = useState("");
  const [custEmail, setCustEmail] = useState();
  const [custAddressLine1, setCustAddressLine1] = useState();
  const [custAddressLine2, setCustAddressLine2] = useState();
  const [custAddressCity, setCustAddressCity] = useState();
  const [custState, setCustState] = useState();
  const [custCountry, setCustCountry] = useState();
  const [custAddressZip, setCustAddressZip] = useState();
  const [custOccupation, setCustOccupation] = useState("");
  const [custGender, setCustGender] = useState("-");
  const [custCategory, setCustCategory] = useState("ADULT");
  const [custDOB, setCustDOB] = useState(null);
  const [custNationality, setCustNationality] = useState("");
  const [govIdType, setGovIdType] = useState("");
  const [govIdNum, setGovIdNum] = useState("");
  const [roomId, setroomId] = useState("");
  const url = new URL(window.location.href);
  const hotelId = url.searchParams.get("hotelId");
  // const [govIdImg, setGovIdImg] = useState()
  const [oldEmail, setoldEmail] = useState("");
  const ishaPurposeOfVisit = getIshaPurposeOfVisit(hotelId);
  const ishaGenderList = getIshaGenderList(hotelId);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  //Additional ISHA Guest config details
  const [custEmergency, setCustEmergency] = useState("");
  const [custEmergencyName, setCustEmergencyName] = useState("");
  const [custCompany, setCustCompany] = useState("");
  const [custPurpose, setCustPurpose] = useState("-");
  const [custRelation, setCustRelation] = useState("");
  const [custOtherRelation, setCustOtherRelation] = useState("");
  const [currentDate, setCurrentDate] = useState(new Date());
  const [custETA, setCustETA] = useState(currentDate);
  const [custETD, setCustETD] = useState(currentDate);
  const [custOCO, setCustOCO] = useState("No");
  const [custApprovedOverseas, setCustApprovedOverseas] = useState("New");
  const [custMedicalCondition, setCustMedicalCondition] = useState("No");
  const [custEventType, setCustEventType] = useState("");
  const [roomIdList, setRoomIdList] = useState(Object.keys(reservationIds));

  const [primaryRoomCustCheck, setPrimaryRoomCustCheck] = useState(false);

  //Guest count map for each room
  const [resInfoMap, setResInfoMap] = useState({});
  const [subUser, setsubUser] = useState(data?.accessControl?.ADMINRIGHTS);

  //Do not rent

  const [Severity, setSeverity] = useState("HIGH");
  const [isDnr, setIsDnr] = useState(false);
  const [dnrReason, setDnrReason] = useState("");
  const [doNotRentData, setDoNotRentData] = useState([]);

  useEffect(() => {
    let res_info_map = {};

    resCurrentConfig.map((res) => {
      res_info_map[res?.reservationId] = res;
      res_info_map[res?.reservationId]["guestAdults"] = 0;
      res_info_map[res?.reservationId]["guestChild"] = 0;
    });

    // reservationInfoData.map((res) => {
    //   res_info_map[res?.reservation_id] = res;
    //   res_info_map[res?.reservation_id]["guestAdults"] = 0;
    //   res_info_map[res?.reservation_id]["guestChild"] = 0;
    // });
    allGuestsList.map((guestData) => {
      let temp_res_id = guestData?.reservationId;
      if (res_info_map[temp_res_id] !== undefined) {
        if (guestData?.guestCategory === "ADULT") {
          if (res_info_map[temp_res_id]?.guestAdults !== undefined) {
            res_info_map[temp_res_id]["guestAdults"] += 1;
          } else {
            res_info_map[temp_res_id]["guestAdults"] = 1;
          }
        } else if (guestData?.guestCategory === "CHILD") {
          if (res_info_map[temp_res_id]?.guestChild !== undefined) {
            res_info_map[temp_res_id]["guestChild"] += 1;
          } else {
            res_info_map[temp_res_id]["guestChild"] = 1;
          }
        } else if (guestData?.guestCategory === "INFANT") {
          if (res_info_map[temp_res_id]?.guestInfant !== undefined) {
            res_info_map[temp_res_id]["guestInfant"] += 1;
          } else {
            res_info_map[temp_res_id]["guestInfant"] = 1;
          }
        }
      }
    });

    setResInfoMap(res_info_map);
  }, [reservationInfoData, allGuestsList, resCurrentConfig]);

  useEffect(() => {
    setRoomIdList(Object.keys(reservationIds));
    setroomId([Object.keys(reservationIds)[0]]);
  }, [reservationIds]);

  const [allowSetPrimaryCustCheck, setAllowSetPrimaryCustCheck] =
    useState(false);
  //Disable/Enable the primary customer check for a given roomId
  useEffect(() => {
    let allowPrimaryCustCheck = true;
    if (oldEmail !== "") {
      allGuestsList.map((guestData) => {
        //Do not allow to set the primary customer of the reservation be the primary customer again
        if (
          guestData?.email == oldEmail &&
          guestData?.roomId == roomId &&
          guestData?.primaryGuest == "YES"
        ) {
          allowPrimaryCustCheck = false;
        }
      });
    }
    setAllowSetPrimaryCustCheck(allowPrimaryCustCheck);
  }, [oldEmail, allGuestsList, roomId]);
  //user id images
  const [UserImagesData, setUserImagesData] = useState(null);

  useEffect(async () => {
    if (datas?.email) {
      const dataUser = await getUserId(datas?.email, {
        name: datas?.name,
        phone: datas?.contact,
      });
      setUserImagesData(dataUser);
    }
  }, [datas?.email]);

  const [selectedPrograms, setSelectedPrograms] = useState(["No"]);
  const handleProgramChange = (event) => {
    const {
      target: { value },
    } = event;
    let attendedPrograms = typeof value === "string" ? value.split(",") : value;
    setSelectedPrograms(attendedPrograms);
  };

  useEffect(() => {
    setCustName(datas === null ? "" : datas?.name);
    console.log("Going to set custId from GuestInformation.js this is the custId: ", datas === null ? "" : datas?.id);
    setCustId(datas === null ? "" : datas?.id);
    setCustContact(datas === null ? "" : datas?.contact);
    setCustEmail(datas === null ? "" : datas?.email);
    setCustAddressLine1(datas === null ? "" : datas?.address1);
    setCustAddressLine2(datas === null ? "" : datas?.address2);
    setCustAddressCity(datas === null ? "" : datas?.city);
    setCustState(datas === null ? "" : datas?.state);
    setCustCountry(datas === null ? "" : datas?.country);
    setCustGender(datas === null ? "-" : datas?.gender);
    setCustOccupation(datas === null ? "" : datas?.occupation);
    setCustCategory(datas === null ? "ADULT" : datas?.guest_category);
    setCustDOB(
      datas === null
        ? ""
        : datas?.date_of_birth === "" || datas?.date_of_birth === "NA"
        ? ""
        : new Date(datas?.date_of_birth)
    );
    setCustNationality(datas === null ? "" : datas?.nationality);
    setCustAddressZip(datas === null ? "" : datas?.zipcode);
    setGovIdType(datas === null ? "" : datas?.govt_id_type);
    setGovIdNum(datas === null ? "" : datas?.govt_id_value);
    setCustEmergency(datas === null ? "" : datas?.emergency_contact);
    setCustEmergencyName(datas === null ? "" : datas?.emergency_contact_name);
    setoldEmail(datas?.email);
    setCustCompany(ishaGuestData === null ? "" : ishaGuestData?.userCompany);
    setroomId(
      datas === null
        ? roomIdList[0]
        : datas?.roomId !== "-1"
        ? datas?.roomId
        : ""
    );
    setCustPurpose(
      ishaGuestData === null ? "-" : ishaGuestData?.purposeOfVisit
    );
    //Isha relationship with primary others condition
    if (
      ishaRelationWithPrimary.indexOf(
        ishaGuestData === null ? "-" : ishaGuestData?.relationshipWithPrimary
      ) === -1
    ) {
      setCustRelation("Other");
      setCustOtherRelation(
        ishaGuestData === null ? "-" : ishaGuestData?.relationshipWithPrimary
      );
    } else {
      setCustRelation(
        ishaGuestData === null ? "-" : ishaGuestData?.relationshipWithPrimary
      );
    }
    if (ishaGuestData?.customerETA !== "") {
      setCustETA(
        new Date(
          moment(
            ishaGuestData?.customerETA,
            "DD-MM-YYYY HH:mm:ss",
            false
          ).format("YYYY-MM-DDTHH:mm:ssZ")
        )
      );
    }
    if (ishaGuestData?.customerETD !== "") {
      setCustETD(
        new Date(
          moment(
            ishaGuestData?.customerETD,
            "DD-MM-YYYY HH:mm:ss",
            false
          ).format("YYYY-MM-DDTHH:mm:ssZ")
        )
      );
    }

    setCustOCO(
      ishaGuestData?.ocoCheckinComplete != ""
        ? ishaGuestData?.ocoCheckinComplete
        : "No"
    );
    setCustApprovedOverseas(
      ishaGuestData?.approvedByOverseas !== ""
        ? ishaGuestData?.approvedByOverseas
        : "New"
    );
    setCustMedicalCondition(
      ishaGuestData?.medicalCondition ? ishaGuestData?.medicalCondition : "No"
    );
    setCustEventType(ishaGuestData?.eventType ? ishaGuestData?.eventType : "");
    let val = ishaGuestData?.programsAttended;
    let attendedPrograms = typeof val === "string" ? val.split(",") : val;
    if (attendedPrograms?.length > 0) {
      setSelectedPrograms(attendedPrograms);
    }
    if (
      datas?.name !== null &&
      datas?.name !== "" &&
      datas?.name !== undefined
    ) {
      emptyValues();
    }
  }, [datas, ishaGuestData]);

  useEffect(() => {
    setImages(
      UserImagesData?.frontUrl ? [{ data_url: UserImagesData.frontUrl }] : []
    );
    setFaviconImages(
      UserImagesData?.backUrl ? [{ data_url: UserImagesData.backUrl }] : []
    );
    setPassportImages(
      UserImagesData?.passportImageUrl
        ? [{ data_url: UserImagesData?.passportImageUrl }]
        : []
    );
  }, [UserImagesData]);
  const handleETAChange = (e) => {
    setCustETA(e);
    //formik.setFieldValue("customer_eta", e);
  };

  const handleETDChange = (e) => {
    setCustETD(e);
    //formik.setFieldValue("customer_etd", e);
  };
  /* Predefining Government Id types */
  // Goverment IDs --- US properties
  const govIdUS = [
    `${t("Passport")}`,
    `${t("Drivers License")}`,
    `${t("Others")}`,
  ];

  // Government IDs --- Indian properties
  const govIdIndia = [
    `${t("Passport")}`,
    `${t("Drivers License")}`,
    `${t("Aadhar")}`,
    `${t("Voter ID")}`,
    `${t("Others")}`,
  ];

  // getting the list of the countries
  // const countries = useMemo(() => countryList().getData(), []);
  const countries = getCountriesAndStates();
  const [countriesPayload, setCountriesPayload] = useState();

  // loader while editing the customer information
  const [editCustLoader, setEditCustLoader] = useState(false);

  //get geoCode details
  const getGeoCodeValues = (zipcode) => {
    try {
      getGeoCodeDetails(zipcode).then((resp) => {
        const re = /^[0-9\b]+$/;
        //Cases where the city is not mentioned in gecoding api
        if (!re.test(resp.city)) {
          setCustAddressCity(resp.city);
        } else {
          setCustAddressCity("");
        }
        setCustState(resp.state);
        setCustCountry(resp.country);
      });
    } catch (e) {
      console.log(e);
    }
  };

  const setDateOfBirthSelection = (dob, isTime) => {
    try {
      setCustDOB(dob);
    } catch (e) {
      console.log(e);
    }
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;

        resolve(baseURL);
      };
    });
  };
  function extractValidChars(str) {
    // Regular expression to allow only numbers, letters, hyphen (-), period (.), and @
    console.log("str", str.replace(/[^a-zA-Z0-9@._-]/g, ""));
    return str.replace(/[^a-zA-Z0-9@._-]/g, "");
  }

  // add new guest information
  const addCustomerDetails = async () => {
    if (datas) {
      await moveUserIdImages(
        hotelId,
        datas.name,
        datas.contact,
        datas.email,
        custName,
        custContact,
        custEmail
      );
    }
    if (custName.trim().length <= 0) {
      toast.error(`${t("Please enter characters in name")}`);
      return;
    }
    let res_info_data = resInfoMap[reservationIds[roomId]];
    if (
      res_info_data !== undefined &&
      custCategory === "ADULT" &&
      res_info_data?.guestAdults + 1 > res_info_data?.maxOccupancy
    ) {
      toast.error(
        `${t(
          "Max adult occupancy reached for given room cannot add customer to room: "
        )}` + roomId
      );
      setEditCustLoader(false);
      return;
    }
    if (
      res_info_data !== undefined &&
      custCategory === "CHILD" &&
      res_info_data?.guestChild + 1 > res_info_data?.maxChildren
    ) {
      toast.error(
        `${t(
          "Max children occupancy reached for given room cannot add customer to room: "
        )}` + roomId
      );
      setEditCustLoader(false);
      return;
    }
    //Validation check for addition of new guest
    if (custName === "") {
      toast.error(`${t("Please enter customer name")}`);
      setEditCustLoader(false);
      return;
    }
    let email =
      custEmail === ""
        ? custName.replace(/[^a-zA-Z0-9]/g, "").toLowerCase() +
          hotelId +
          Math.round(Date.now() / 1000) +
          "@example.com"
        : custEmail;
    email = extractValidChars(email?.trim());
    let tempDob = "";
    if (custDOB != "" && custDOB != "NA") {
      tempDob = format(custDOB, "yyyy-MM-dd");
    }
    setEditCustLoader(true);
    //Need to compress the base64 only for device upload
    let tempFrontDataImage =
      images[0] !== undefined ? images[0]?.file : undefined;
    let tempBackDataImage =
      faviconImages[0] !== undefined ? faviconImages[0]?.file : undefined;
    let tempPassportImage =
      passportImages[0] !== undefined ? passportImages[0]?.file : undefined;
    const options = {
      maxSizeMB: maxCompressMBSize,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    let compressedFrontData = null;
    let compressedBackData = null;
    let compressedPassportData = null;
    if (tempFrontDataImage !== undefined) {
      const compressedFile = await imageCompression(
        tempFrontDataImage,
        options
      );
      await getBase64(compressedFile)
        .then((result) => {
          compressedFile["base64"] = result;
          compressedFrontData = result;
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (tempBackDataImage !== undefined) {
      const compressedFile = await imageCompression(tempBackDataImage, options);
      await getBase64(compressedFile)
        .then((result) => {
          compressedFile["base64"] = result;
          compressedBackData = result;
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (tempPassportImage !== undefined) {
      const compressedFile = await imageCompression(tempPassportImage, options);
      await getBase64(compressedFile)
        .then((result) => {
          compressedFile["base64"] = result;
          compressedPassportData = result;
        })
        .catch((err) => {
          console.log(err);
        });
    }

    const ctaResData = CTAData?.filter((item) => item.cta_email === email);

    if (ctaResData.length >= 1) {
      return toast.error(
        "Please enter different email id this email is already linked with direct billing account"
      );
    }

    const payload = {
      id: custId,
      bookingId: bookingId,
      name: custName?.trim(),
      contact: custContact?.trim(),
      email: extractValidChars(email?.trim()),
      address1: custAddressLine1,
      address2: custAddressLine2,
      city: custAddressCity,
      state: custState,
      country: custCountry,
      zipcode: custAddressZip,
      govtIdType: govIdType,
      govtIdValue: govIdNum,
      roomId: roomId,
      hotelId: hotelId,
      nationality: custNationality,
      occupation: custOccupation,
      gender: custGender,
      dateOfBirth: tempDob,
      oldEmail: email,
      guestCategory: custCategory,
      reservationId: reservationIds[roomId],
    };
    const userIdPayload = {
      emailId: email,
      frontData:
        images.length > 0
          ? images[0].data_url.split(",")[1]
          : compressedFrontData !== null
          ? compressedFrontData?.split(",")[1]
          : null,
      frontType:
        images.length > 0 ? "jpeg" : images[0] ? images[0].file?.type : null,
      backData:
        faviconImages.length > 0
          ? faviconImages[0].data_url.split(",")[1]
          : compressedBackData !== null
          ? compressedBackData?.split(",")[1]
          : null,
      backType:
        faviconImages.length > 0
          ? "jpeg"
          : faviconImages[0]
          ? faviconImages[0]?.file?.type
          : null,
      passportImageData:
        passportImages.length > 0
          ? passportImages[0]?.data_url?.split(",")[1]
          : compressedPassportData !== null
          ? compressedPassportData?.split(",")[1]
          : null,
      passportImageType:
        passportImages.length > 0
          ? "jpeg"
          : passportImages[0]
          ? passportImages[0]?.file?.type
          : null,
      hotelId: hotelId,
    };
    let custRelationData = custRelation;
    if (custRelation === "Other") {
      custRelationData = custOtherRelation;
    }
    if (
      userIdPayload?.frontData !== undefined ||
      userIdPayload?.backData !== undefined ||
      userIdPayload?.passportImageData !== undefined
    ) {
      if (custName === "") {
        toast.error(`${t("Please enter name !")}`);
      } else {
        if (
          userIdPayload.frontData !== null ||
          userIdPayload.backData !== null ||
          userIdPayload.passportImageData !== null
        ) {
          await setBookingUserIdImages({...userIdPayload, name: custName, phone: custContact});
        }
      }
    }
    await addEditGuestUser(payload).then(() => {
      govIdNum && isDnr && createDoNotRentStatus(payload?.email);
    });
    if (
      JSON.parse(data?.accessControl?.user_feature_map?.IshaExtraGuestDetails)
        .read === "YES" &&
      (checkIshaAccess(data?.emailId) || checkIshaUSAccess(data?.emailId))
    ) {
      const ishaPayload = {
        userEmail: payload?.email,
        userPhone: payload?.contact,
        purposeOfVisit: custPurpose,
        programsAttended: selectedPrograms?.toString(),
        relationshipWithPrimary: custRelationData,
        userCompany: custCompany,
        customerETA: moment(custETA).format("DD-MM-YYYY HH:mm:ss"),
        customerETD: moment(custETD).format("DD-MM-YYYY HH:mm:ss"),
        ocoCheckinComplete: custOCO,
        approvedByOverseas: custApprovedOverseas,
        medicalCondition: custMedicalCondition,
        eventType: custEventType,
      };
      await setIshaGuestConfig(ishaPayload);
    }
    // if (roomId !== "") {
    //   await updateGuestCount({
    //     bookingId: bookingId,
    //     roomId: roomId,
    //     updateType: "ADD_GUEST",
    //     guestType: "ADULTS",
    //   }).then((resp) => toast.success("Updated guest count for booking."));
    // }

    if (
      (custCategory === "ADULT" &&
        res_info_data?.numAdults === res_info_data?.guestAdults) ||
      (custCategory === "CHILD" &&
        res_info_data?.numChildren === res_info_data?.guestChild)
    ) {
      pricingUpdatingFunc("ADD");
    } else {
      toast.success(`${t("Successfully saved guest user")}`);
      updateData();
      setEditCustLoader(false);
    }

    if (
      hotel?.accessControl?.hotel?.enable_id_scanner === "IDGURU" &&
      Object.entries(selectedUserIdGuruData).length > 0
    ) {
      handleSpringDataMutationRequest(
        `PUT`,
        `core/api/v1/idguru/mark-id-used?id=${selectedUserIdGuruData.id}`
      )
        .then((res) => console.log("res", res))
        .catch((err) => console.error(err.response.data));
    }
  };

  // update the customer details
  const updateCustomerDetails = async () => {
    if (datas) {
      await moveUserIdImages(
        hotelId,
        datas.name,
        datas.contact,
        datas.email,
        custName,
        custContact,
        custEmail
      );
    }
    if (custName.trim().length <= 0) {
      toast.error(`${t("Please enter characters in name")}`);
      return;
    }
    if (checkIshaUSAccess(data?.emailId) && custGender == "-") {
      toast.error(`${t("Please select gender for the customer")}`);
      return;
    }
    if (checkIshaUSAccess(data?.emailId) && custPurpose == "-") {
      toast.error(`${t("Please enter a purpose of visit for the customer")}`);
      return;
    }

    let email =
      custEmail === ""
        ? custName.replace(/[^a-zA-Z0-9]/g, "").toLowerCase() +
          hotelId +
          Math.round(Date.now() / 1000) +
          "@example.com"
        : custEmail;
    email = extractValidChars(email?.trim());
    let tempDob = "";
    if (custDOB != "" && custDOB != "NA") {
      tempDob = format(custDOB, "yyyy-MM-dd");
    }
    const ctaResData = CTAData?.filter((item) => item.cta_email === email);

    if (ctaResData.length >= 1) {
      return toast.error(
        "Please enter different email id this email is already linked with direct billing account"
      );
    }
    setEditCustLoader(true);
    //Need to compress the base64 only for device upload
    let tempFrontDataImage =
      images[0] !== undefined ? images[0]?.file : undefined;
    let tempBackDataImage =
      faviconImages[0] !== undefined ? faviconImages[0]?.file : undefined;
    let tempPassportImage =
      passportImages[0] !== undefined ? passportImages[0]?.file : undefined;
    const options = {
      maxSizeMB: maxCompressMBSize,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    let compressedFrontData = null;
    let compressedBackData = null;
    let compressedPassportData = null;
    if (tempFrontDataImage !== undefined) {
      const compressedFile = await imageCompression(
        tempFrontDataImage,
        options
      );
      await getBase64(compressedFile)
        .then((result) => {
          compressedFile["base64"] = result;
          compressedFrontData = result;
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (tempBackDataImage !== undefined) {
      const compressedFile = await imageCompression(tempBackDataImage, options);
      await getBase64(compressedFile)
        .then((result) => {
          compressedFile["base64"] = result;
          compressedBackData = result;
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (tempPassportImage !== undefined) {
      const compressedFile = await imageCompression(tempPassportImage, options);
      await getBase64(compressedFile)
        .then((result) => {
          compressedFile["base64"] = result;
          compressedPassportData = result;
        })
        .catch((err) => {
          console.log(err);
        });
    }
    const payload = {
      id: custId,
      bookingId: bookingId,
      name: custName?.trim(),
      contact: custContact?.trim(),
      email: extractValidChars(email?.trim()),
      address1: custAddressLine1,
      address2: custAddressLine2,
      city: custAddressCity,
      state: custState,
      country: custCountry,
      zipcode: custAddressZip,
      govtIdType: govIdType,
      govtIdValue: govIdNum,
      roomId: roomId,
      hotelId: hotelId,
      nationality: custNationality,
      occupation: custOccupation,
      gender: custGender,
      dateOfBirth: tempDob,
      oldEmail: oldEmail,
      guestCategory: custCategory,
      reservationId: datas?.reservation_id,
    };
    const userIdPayload = {
      emailId: email,
      frontData:
        image !== undefined
          ? image.split(",")[1]
          : compressedFrontData !== null
          ? compressedFrontData?.split(",")[1]
          : null,
      frontType:
        image !== undefined ? "jpeg" : images[0] ? images[0].file?.type : null,
      backData:
        backImage !== undefined
          ? backImage.split(",")[1]
          : compressedBackData !== null
          ? compressedBackData?.split(",")[1]
          : null,
      backType:
        backImage !== undefined
          ? "jpeg"
          : faviconImages[0]
          ? faviconImages[0]?.file?.type
          : null,
      passportImageData:
        passportImage != undefined
          ? passportImage.split(",")[1]
          : compressedPassportData !== null
          ? compressedPassportData?.split(",")[1]
          : null,
      passportImageType:
        passportImage != undefined
          ? "jpeg"
          : passportImages[0]
          ? passportImages[0]?.file?.type
          : null,
      hotelId: hotelId,
    };

    if (oldEmail !== email) {
      await imageUpdateByEmail(oldEmail, email);
    }
    if (
      userIdPayload?.frontData !== undefined ||
      userIdPayload?.backData !== undefined ||
      userIdPayload?.passportImageData !== undefined
    ) {
      if (custName === "") {
        toast.error(`${t("Please enter name !")}`);
      } else {
        if (
          userIdPayload.frontData !== null ||
          userIdPayload.backData !== null ||
          userIdPayload.passportImageData !== null
        ) {
          await setBookingUserIdImages({...userIdPayload, name: custName, phone: custContact});
        }
      }
    }
    if (custName === "") {
      toast.error(`${t("Please enter name !")}`);
    } else {
      //if the customer is already a primary customer or the customer is set as primary option
      if (custId === primaryGuestId || String(primaryCheck) === "true") {
        let tempGuestDOB = "";
        if (custDOB != "") {
          tempGuestDOB = format(custDOB, "yyyy-MM-dd");
        }
        let custRelationData = custRelation;
        if (custRelation === "Other") {
          custRelationData = custOtherRelation;
        }
        console.log("Going to call updateCustomerDetails from GuestInformation.js this is the custId: ", custId);
        handleSpringDataMutationRequest(
          "PUT",
          `user/updateCustomerDetails/?resId=${bookingId}&reservationId=${datas?.reservation_id}&roomId=${roomId}`,
          {
            id: custId,
            userName: custName,
            address: custAddressLine1,
            address1: custAddressLine2,
            city: custAddressCity,
            state: custState,
            country: custCountry,
            phoneNumber: custContact,
            zipCode: custAddressZip,
            email: extractValidChars(email?.trim()),
            govtIdType: govIdType,
            govtIdValue: govIdNum,
            dateOfBirth: tempGuestDOB,
            gender: custGender,
            nationality: custNationality,
            occupation: custOccupation,
            purpose_of_visit: custPurpose,
            company_name: custCompany,
            programs_attended: selectedPrograms?.toString(),
            relationship_with_primary: custRelationData,
            emergency_contact: custEmergency,
            emergency_contact_name: custEmergencyName,
            customer_eta: moment(custETA).format("DD-MM-YYYY HH:mm:ss"),
            customer_etd: moment(custETD).format("DD-MM-YYYY HH:mm:ss"),
            customer_oco_checkin: custOCO,
            customer_approved_overseas: custApprovedOverseas,
            customer_medical_condition: custMedicalCondition,
            event_type: custEventType,
            old_email: oldEmail,
            guest_category: custCategory,
          }
        )
          .then((res) => {
            govIdNum &&
              isDnr &&
              createDoNotRentStatus(extractValidChars(email?.trim()));
            toast.success(`${t("Successfully updated user")}`);
          })
          .then((res) => updateData())
          .then((res) => setEditCustLoader(false))
          .catch((err) => toast.error(`${t("Something went wrong")}`))
          .catch((err) => setEditCustLoader(false));
      } else {
        let custRelationData = custRelation;
        if (custRelation === "Other") {
          custRelationData = custOtherRelation;
        }
        await addEditGuestUser(payload).then(() => {
          govIdNum && isDnr && createDoNotRentStatus(payload?.email);
        });
        if (
          JSON.parse(
            data?.accessControl?.user_feature_map?.IshaExtraGuestDetails
          ).read === "YES" &&
          (checkIshaAccess(data?.emailId) || checkIshaUSAccess(data?.emailId))
        ) {
          const ishaPayload = {
            userEmail: payload?.email,
            userPhone: payload?.contact,
            purposeOfVisit: custPurpose,
            programsAttended: selectedPrograms?.toString(),
            relationshipWithPrimary: custRelationData,
            userCompany: custCompany,
            customerETA: moment(custETA).format("DD-MM-YYYY HH:mm:ss"),
            customerETD: moment(custETD).format("DD-MM-YYYY HH:mm:ss"),
            ocoCheckinComplete: custOCO,
            approvedByOverseas: custApprovedOverseas,
          };
          await setIshaGuestConfig(ishaPayload);
        }
        toast.success(`${t("Successfully saved guest user")}`);
        setEditCustLoader(false);
      }
      if (String(primaryCheck) === "true") {
        const data = await updatePrimaryGuest({
          id: custId,
          emailId: custEmail,
          bookingId: bookingId,
          reservationId: datas?.reservation_id,
        })
          .then((resp) =>
            toast.success(
              `${t("Successfully updated primary customer for booking")}`
            )
          )
          .catch((err) => console.log(err));
      }

      if (
        hotel?.accessControl?.hotel?.enable_id_scanner === "IDGURU" &&
        Object.entries(selectedUserIdGuruData).length > 0
      ) {
        handleSpringDataMutationRequest(
          `PUT`,
          `core/api/v1/idguru/mark-id-used?id=${selectedUserIdGuruData.id}`
        )
          .then((res) => console.log("res", res))
          .catch((err) => console.error(err.response.data));
      }
    }

    if (primaryRoomCustCheck) {
      let roomCustPayload = {
        bookingId: bookingId,
        resId: reservationIds[roomId],
        customerEmail: payload?.email,
        oldCustomerEmail: payload?.oldEmail,
        customerPhone: payload?.contact,
        customerName: payload?.name,
      };
      const data = await setRoomPrimary(roomCustPayload)
        .then((resp) =>
          toast.success(
            `${
              t("Successfully updated primary customer for roomId: ") + roomId
            }`
          )
        )
        .catch((err) => console.log(err));
    }
    guestDataList();

    setshowUserIdImages(0);
    setshowUserIdImagesback(0);

    if (scanIdState === "true") {
      scanIdpayload.emailId = email;
      const data = await setBookingUserIdImages({
        ...scanIdpayload,
        name: custName,
        phone: custContact,
      });
      if (data === "Failed to upload new image") {
        toast.error(`${t("Something went wrong !")}`);
      }
      await getUserId(email, { name: custName, phone: custContact });
    }
    setscanIdState("false");
  };

  //Scan User id
  const [scanIdState, setscanIdState] = useState("false");
  const [scanIdpayload, setscanIdpayload] = useState({});
  const [ScannerData, setScannerData] = useState();
  const [loading, setloading] = useState(false);
  const getScannerUrl = () => {
    if (
      `${process.env.REACT_APP_ENV}` === "BETA" ||
      `${process.env.REACT_APP_ENV}` === "LOCAL"
    ) {
      return "https://text.motelpro.com/ScanDocDemo?images=front+back";
    } else if (`${process.env.REACT_APP_ENV}` === "PROD") {
      return "http://127.0.0.1:55080/scandoc?images=front+back";
    } else {
      return "http://127.0.0.1:55080/scandoc?images=front+back";
    }
  };

  const [showUserIdImages, setshowUserIdImages] = useState(0);
  const [showUserIdImagesback, setshowUserIdImagesback] = useState(0);

  //Disable save button
  const [disableSave, setDisableSave] = useState(false);
  useEffect(() => {
    if (
      JSON.parse(data?.accessControl?.user_feature_map?.IshaExtraGuestDetails)
        .read === "YES" &&
      (checkIshaAccess(data?.emailId) || checkIshaUSAccess(data?.emailId))
    ) {
      if (custContact != "" && custContact == custEmergency) {
        setDisableSave(true);
      } else {
        setDisableSave(false);
      }
    }
  }, [custContact, custEmergency]);

  const [Scandata, setScandata] = useState();

  const getIdValue = (type) => {
    if (type === "DrivingLicense") {
      return "Drivers License";
    } else if (type === "Passport") {
      return "Passport";
    } else {
      return "Others";
    }
  };

  //ID  Guru
  const [idGuruModal, setidGuruModal] = useState(false);
  const [selectedUserIdGuruData, setselectedUserIdGuruData] = useState({});
  const handleOpenIdGuruModal = () => {
    setidGuruModal(true);
  };
  const handleCloseIdGuruModal = () => {
    setidGuruModal(false);
  };

  useEffect(() => {
    if (
      Object.entries(selectedUserIdGuruData).length > 0 &&
      idGuruModal === false
    ) {
      scannedIdGuruData();
    }
  }, [selectedUserIdGuruData, idGuruModal]);

  const scannedIdGuruData = () => {
    setimageUpload("Device");
    setImages(
      selectedUserIdGuruData?.data?.idFrontImage_Base64
        ? [
            {
              data_url: `data:image/png;base64,${selectedUserIdGuruData?.data?.idFrontImage_Base64}`,
            },
          ]
        : []
    );
    setFaviconImages(
      selectedUserIdGuruData?.data?.idBackImage_Base64
        ? [
            {
              data_url: `data:image/png;base64,${selectedUserIdGuruData?.data?.idBackImage_Base64}`,
            },
          ]
        : []
    );
    setshowUserIdImages(1);
    setshowUserIdImagesback(1);

    let customer_name =
      selectedUserIdGuruData.data.firstName +
      " " +
      selectedUserIdGuruData.data.middleName +
      " " +
      selectedUserIdGuruData.data.lastName;

    let dummy_email =
      customer_name.replace(/[^a-zA-Z0-9]/g, "").toLowerCase() +
      hotelId +
      Math.round(Date.now() / 1000) +
      "@example.com";

    setCustState(selectedUserIdGuruData?.data?.state);
    setCustAddressZip(selectedUserIdGuruData?.data?.zipCode);
    setCustAddressCity(selectedUserIdGuruData?.data?.city);
    setCustAddressLine1(selectedUserIdGuruData?.data?.streetAddress);
    setGovIdNum(selectedUserIdGuruData?.data?.idNumber);
    setGovIdType(getIdValue(selectedUserIdGuruData?.data?.idType));
    setCustCountry("United States");
    setCustName(customer_name);
    setCustContact(
      selectedUserIdGuruData?.data?.phoneCountryCode +
        selectedUserIdGuruData?.data?.phoneAreaCode +
        selectedUserIdGuruData?.data?.phoneNumber
    );
    setCustEmail(selectedUserIdGuruData?.data?.emailAddress);

    const userIdPayload = {
      emailId: "",
      frontData: selectedUserIdGuruData?.data?.idFrontImage_Base64,
      frontType: "png",
      backData: selectedUserIdGuruData?.data?.idBackImage_Base64,
      backType: "png",
      hotelId: hotelId,
    };
    setscanIdpayload(userIdPayload);
    setscanIdState("true");
  };
  const ScannedData = async () => {
    const URL = getScannerUrl();
    setloading(true);
    const ApiData = await fetch(URL)
      .then((data) => {
        return data.json();
      })
      .catch((err) => {
        throw new Error(err);
      });
    setloading(false);
    setScannerData(ApiData?.apiresponse);
    // setImageFront();
    // setImageBack();
    setImages(
      ApiData?.apiresponse?.imgfront
        ? [
            {
              data_url: `data:image/png;base64,${ApiData?.apiresponse?.imgfront}`,
            },
          ]
        : []
    );
    setFaviconImages(
      ApiData?.apiresponse?.imgback
        ? [
            {
              data_url: `data:image/png;base64,${ApiData?.apiresponse?.imgback}`,
            },
          ]
        : []
    );
    setshowUserIdImages(1);
    setshowUserIdImagesback(1);

    if (ApiData?.apiresponse?.errormsg?.cd === 0) {
      setCustState(ApiData?.apiresponse?.docinfo?.state);
      setCustAddressZip(ApiData?.apiresponse?.docinfo?.zipcode);
      setCustAddressCity(ApiData?.apiresponse?.docinfo?.city);
      setCustAddressLine1(ApiData?.apiresponse?.docinfo?.addr1);
      setGovIdNum(ApiData?.apiresponse?.docinfo?.idno);
      setGovIdType("Drivers License");
      setCustCountry("United States");
      let customer_name = "";
      if (ApiData?.apiresponse?.docinfo?.fullname) {
        customer_name = ApiData?.apiresponse?.docinfo?.fullname;
      } else {
        customer_name =
          ApiData?.apiresponse?.docinfo?.fname +
          ApiData?.apiresponse?.docinfo?.lname;
      }
      setCustName(customer_name);
      let dummy_email =
        customer_name.replace(/[^a-zA-Z0-9]/g, "").toLowerCase() +
        hotelId +
        Math.round(Date.now() / 1000) +
        "@example.com";
      // setCustEmail(dummy_email);
      const userIdPayload = {
        emailId: "",
        frontData: ApiData?.apiresponse?.imgfront,
        // frontData:
        //   "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",
        // backData:
        //   "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",
        frontType: "png",
        backData: ApiData?.apiresponse?.imgback,
        backType: "png",
        hotelId: hotelId,
      };
      setscanIdpayload(userIdPayload);
      setscanIdState("true");
    } else {
      toast.error(ApiData?.apiresponse?.errormsg?.txt);
    }
  };

  const stripDataUrlPrefix = (dataUrl) =>
    dataUrl ? dataUrl.replace(/^data:image\/\w+;base64,/, "") : "";

  const handleAmbirScanWebConnectFields = useCallback((fields) => {
    setCustState(fields.state);
    setCustAddressZip(fields.zipcode);
    setCustAddressCity(fields.city);
    setCustAddressLine1(fields.address1);
    setGovIdNum(fields.govtIdValue);
    setGovIdType(fields.govtIdType);
    setCustCountry(fields.country);
    setCustName(fields.fullName);
    if (fields.dateOfBirth) setCustDOB(parseDateOfBirth(fields.dateOfBirth));
    if (fields.gender) setCustGender(fields.gender);
  }, []);

  const handleAmbirScanWebConnectImages = useCallback(
    ({ frontImage, backImage }) => {
      setImages(frontImage ? [{ data_url: frontImage }] : []);
      setFaviconImages(backImage ? [{ data_url: backImage }] : []);
      setshowUserIdImages(1);
      setshowUserIdImagesback(1);
      setscanIdpayload({
        emailId: "",
        frontData: stripDataUrlPrefix(frontImage),
        frontType: "png",
        backData: stripDataUrlPrefix(backImage),
        backType: "png",
        hotelId: hotelId,
      });
      setscanIdState("true");
    },
    [hotelId]
  );

  const {
    startScan: startWebConnectScan,
    isScanning: isWebConnectScanning,
    pickerProps: webConnectPickerProps,
  } = useAmbirScanWebConnect({
    onFields: handleAmbirScanWebConnectFields,
    onImages: handleAmbirScanWebConnectImages,
  });

  const [ImagesData, setImagesData] = useState();
  const [imageFront, setImageFront] = useState();
  const [imageBack, setImageBack] = useState();

  const [showFrontImagePopup, setshowFrontImagePopup] = useState(false);
  const [showPopUpImages, setshowPopUpImages] = useState("");

  const handleshowFrontImagePopupClose = () => setshowFrontImagePopup(false);
  const handleFrontImagePopupShow = (data) => {
    setshowPopUpImages(data);
    setshowFrontImagePopup(true);
  };
  //images

  const [images, setImages] = useState([]);

  const [faviconImages, setFaviconImages] = useState([]);

  const { hotel } = useSelector(
    ({ auth }) => ({
      hotel: auth.selectedHotel,
    }),
    shallowEqual
  );

  //Passport image - isha requirement
  const [passportImageUpload, setPassportImageUpload] = useState("Device");
  const [showPassportModal, setShowPassportModal] = useState(false);
  const handleClosePassportModal = () => setShowPassportModal(false);
  const handleOpenPassportModal = () => setShowPassportModal(true);
  const [passportImage, setPassportImage] = useState(undefined);
  const passportCapture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setPassportImage(imageSrc);
  }, [webcamRef]);
  const [passportImages, setPassportImages] = useState([]);

  //Add Travel Agent Modal
  const [modalShow, setModalShow] = useState(false);
  const [imgURL, setImgURL] = useState("");
  const [title, setTitle] = useState("");

  const handleModalClose = () => setModalShow(false);
  const handleModalShow = (tit, url) => {
    setTitle(tit);
    setImgURL(url);
    setModalShow(true);
  };

  const downloadImage = (url) => {
    saveAs(url, "image.jpg");
  };

  const [customerNameData, setcustomerNameData] = useState([]);
  const [customerPhoneData, setcustomerPhoneData] = useState([]);
  const [customerEmailData, setcustomerEmailData] = useState([]);
  const [showData, setshowData] = useState(true);

  useEffect(async () => {
    if (
      datas?.name !== null &&
      datas?.name !== "" &&
      datas?.name !== undefined
    ) {
      emptyValues();
    } else {
      if (custName !== "") {
        const data = await getAllCustomers(custName, "name");
        const sortedArr = data.reduce((acc, element) => {
          if (element.donotRent === "YES") {
            return [element, ...acc];
          }
          return [...acc, element];
        }, []);
        setcustomerNameData(sortedArr);
      }
      if (custName?.length === 1) {
        setcustomerNameData([]);
      }
      if (custName === "") {
        setshowData(true);
      }
    }
  }, [custName, datas?.name]);

  useEffect(async () => {
    if (
      datas?.email !== null &&
      datas?.email !== "" &&
      datas?.email !== undefined
    ) {
      emptyValues();
    } else {
      if (custEmail !== "") {
        const data = await getAllCustomers(custEmail, "email");
        const sortedArr = data.reduce((acc, element) => {
          if (element.donotRent === "YES") {
            return [element, ...acc];
          }
          return [...acc, element];
        }, []);
        setcustomerEmailData(sortedArr);
      }
      if (custEmail?.length === 1) {
        setcustomerEmailData([]);
      }
      if (custEmail === "") {
        setshowData(true);
      }
    }
  }, [custEmail, datas?.email]);

  useEffect(async () => {
    if (
      datas?.contact !== null &&
      datas?.contact !== "" &&
      datas?.contact !== undefined
    ) {
      emptyValues();
    } else {
      if (custContact !== "") {
        const data = await getAllCustomers(custContact, "contact");

        const sortedArr = data.reduce((acc, element) => {
          if (element.donotRent === "YES") {
            return [element, ...acc];
          }
          return [...acc, element];
        }, []);
        setcustomerPhoneData(sortedArr);
      }
      if (custContact?.length === 1) {
        setcustomerPhoneData([]);
      }
      if (custContact === "") {
        setshowData(true);
      }
    }
  }, [custContact, datas?.contact]);

  const populateCustomerFeilds = (item) => {
    setCustName(item.name);
    setCustContact(item.contact);
    setCustEmail(item.email);
    setcustomerEmailData([]);
    setcustomerNameData([]);
    setcustomerPhoneData([]);
    setshowData(false);
  };

  const webcamRef = React.useRef(null);

  const [image, setImage] = useState(undefined);
  const [backImage, setBackImage] = useState(undefined);

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
  }, [webcamRef]);

  const backcapture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setBackImage(imageSrc);
  }, [webcamRef]);

  const videoConstraints = {
    width: 400,
    height: 300,
    facingMode: "user",
  };

  const [imageUpload, setimageUpload] = useState("Device");

  const [showFrontIdModal, setshowFrontIdModal] = useState(false);

  const handleCloseFrontIdModal = () => setshowFrontIdModal(false);
  const handleOpenFrontIdModal = () => {
    setshowFrontIdModal(true);
  };

  const [showBackIdModal, setshowBackIdModal] = useState(false);

  const handleCloseBackIdModal = () => setshowBackIdModal(false);
  const handleOpenBackIdModal = () => {
    setshowBackIdModal(true);
  };

  const emptyValues = () => {
    setcustomerNameData([]);
    setcustomerEmailData([]);
    setcustomerPhoneData([]);
  };

  const deleteHotelLogo = (id) => {
    let data;
    if (id === "front") {
      data = images && images[0]?.data_url;
    } else if (id === "back") {
      data = faviconImages && faviconImages[0]?.data_url;
    } else {
      data = passportImages && passportImages[0]?.data_url;
    }

    if (data?.includes("defaultLogo")) {
    } else {
      const splitUrl = data.split(".blob.core.windows.net/");
      axios
        .get(
          `${process.env.REACT_APP_BG_API_URL}core/api/v1/image/delete-image?imagePath=${splitUrl[1]}`
        )
        .then((res) => {
          toast.success(`${t("Successfully deleted image")}`);
          getUserId(custEmail, { name: custName, phone: custContact });
        })
        .catch((err) => toast.error(`${t("Error in deleting image")}`));
    }
  };

  //Add Do Not rent
  const [dshow, setDShow] = useState(false);

  const handleDClose = () => setDShow(false);
  const handleDShow = () => setDShow(true);

  //Add Do Not rent
  const [rshow, setRShow] = useState(false);
  const [doNotRentLoad, setDoNoRentLoad] = useState(false);

  const handleRClose = () => setRShow(false);
  const handleRShow = () => setRShow(true);
  const [checked, setChecked] = React.useState(false);
  const [doNotRent, setDoNotRent] = useState(null);

  const createDoNotRentStatus = async (email) => {
    setloading(true);
    const payload = {
      hotelId: hotel.hotelId,
      emailId: email,
      severity: Severity,
      reason: dnrReason,
    };

    const data = await addNewDoNotRentStatus(payload);
    setloading(false);
    if (data.status === 200) {
      toast.success(`${t("Successfully added Do-Not rent status")}`);
    } else {
      toast.error(`${t("Something went wrong !")}`);
    }
    setChecked(false);
    await getCustomerNotes(custEmail);
    updateData();
    handleDClose();
  };

  const removeDoNotRentStatus = async () => {
    setloading(true);
    const payload = {
      hotelId: hotel.hotelId,
      emailId: custEmail,
      status: "NO",
      severity: Severity,
    };
    const data = await removeNewDoNotRentStatus(payload);
    setloading(false);
    if (data.status === 200) {
      toast.success(`${t("Successfully removed Do-Not rent status")}`);
    } else {
      toast.error(`${t("Something went wrong !")}`);
    }
    setChecked(false);
    await getCustomerNotes(custEmail);
    updateData();
    handleRClose();
  };

  const getDoNotRentStatus = (email) => {
    handleSpringDataRequest(`core/api/v1/do-not-rent/get-all?emailId=${email}`)
      .then((res) => {
        setDoNotRent(res[0]);
      })
      .catch((err) => {
        console.log("The err is : ", err);
      });
  };

  //Primary customer set check
  const [primaryCheck, setPrimaryCheck] = useState(false);

  //Delete customer functionality
  const [deleteCustLoader, setDeleteCustLoader] = useState(false);
  const deleteCustomer = async () => {
    setDeleteCustLoader(true);
    const data = await removeCustomerBooking({
      emailId: custEmail,
      bookingId: bookingId,
      roomId: roomId,
    })
      .then((resp) => {
        let res_info_data = resInfoMap[reservationIds[roomId]];
        if (
          (custCategory === "ADULT" &&
            res_info_data?.numAdults === res_info_data?.guestAdults) ||
          (custCategory === "CHILD" &&
            res_info_data?.numChildren === res_info_data?.guestChild)
        ) {
          pricingUpdatingFunc("REMOVE");
        } else {
          updateData();
          toast.success("Successfully deleted customer from booking");
          setEditCustLoader(false);
          setDeleteCustLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setDeleteCustLoader(false);
      });
  };

  //Pricing change modal
  const [pricingUpdateModal, setPricingUpdateModal] = useState(false);
  const [updatePricing, setUpdatePricing] = useState(false);

  const handlePricingUpdateModalShow = () => setPricingUpdateModal(true);
  const handlePricingUpdateModalClose = () => setPricingUpdateModal(false);

  const [editPriceCheck, setEditPriceCheck] = useState(false);
  const [updatedAdults, setUpdatedAdults] = useState(0);
  const [updatedChild, setUpdatedChild] = useState(0);
  const [updatedPrice, setUpdatedPrice] = useState(0);
  const [deleteCustCheck, setDeleteCustCheck] = useState(false);

  const [falseLoader, setFalseLoader] = useState(false);

  const pricingUpdatingFunc = async (updateType) => {
    let selected_res_id = reservationIds[roomId];
    let res_info_map_data = resInfoMap[selected_res_id];
    let tempAdults = res_info_map_data?.guestAdults
      ? res_info_map_data?.guestAdults
      : res_info_map_data?.numAdults;
    let tempChild = res_info_map_data?.guestChild
      ? res_info_map_data?.guestChild
      : res_info_map_data?.numChildren;
    if (custCategory === "ADULT") {
      if (updateType === "ADD") {
        tempAdults += 1;
      } else if (updateType === "REMOVE") {
        tempAdults -= 1;
      }
    } else if (custCategory === "CHILD") {
      if (updateType === "ADD") {
        tempChild += 1;
      } else if (updateType === "REMOVE") {
        tempChild -= 1;
      }
    }
    if (updateType === "ADD") {
      setDeleteCustCheck(false);
    } else if (updateType === "REMOVE") {
      setDeleteCustCheck(true);
    }
    setUpdatedAdults(tempAdults);
    setUpdatedChild(tempChild);
    //Fetch the price for this updated pricing
    const data = await getAllChangedPrice(
      selected_res_id,
      tempAdults,
      tempChild
    )
      .then((data) => setUpdatedPrice(data))
      .then(() => handlePricingUpdateModalShow());
  };

  const guestUpdateFuncWithPricing = async () => {
    setloading(true);

    let selected_res_id = reservationIds[roomId];
    let payload = {
      bookingId: bookingId,
      roomId: roomId,
      reservationId: selected_res_id,
      updateType: "ADD_GUEST",
      guestType: custCategory,
      updatePricing: "YES",
      setCustomPricing: editPriceCheck,
      updatedPrice: updatedPrice,
    };
    const data = await updateGuestCount(payload)
      .then(() => updateData())
      .then(() => setloading(false))
      .then(() => toast.success(`${t("Successfully added guest user")}`))
      .then(() =>
        toast.success(`${t("Successfully updated guest count with pricing")}`)
      );
  };

  const guestUpdateFuncWithoutPricing = async () => {
    setFalseLoader(true);

    let selected_res_id = reservationIds[roomId];
    let payload = {
      bookingId: bookingId,
      roomId: roomId,
      reservationId: selected_res_id,
      updateType: "ADD_GUEST",
      guestType: custCategory,
      updatePricing: "NO",
      setCustomPricing: editPriceCheck,
      updatedPrice: updatedPrice,
    };
    const data = await updateGuestCount(payload)
      .then(() => updateData())
      .then(() => setFalseLoader(false))
      .then(() => toast.success(`${t("Successfully added guest user")}`))
      .then(() => toast.success(`${t("Successfully updated guest count")}`));
  };

  const guestUpdateReduceCountWithPricing = async () => {
    setloading(true);

    let selected_res_id = reservationIds[roomId];
    let payload = {
      bookingId: bookingId,
      roomId: roomId,
      reservationId: selected_res_id,
      updateType: "REMOVE_GUEST",
      guestType: custCategory,
      updatePricing: "YES",
      setCustomPricing: editPriceCheck,
      updatedPrice: updatedPrice,
    };
    const data = await updateGuestCount(payload)
      .then(() => updateData())
      .then(() => setloading(false))
      .then(() => toast.success(`${t("Successfully removed guest user")}`))
      .then(() =>
        toast.success(`${t("Successfully updated guest count with pricing")}`)
      );
  };

  const guestUpdateReduceCountWithoutPricing = async () => {
    setFalseLoader(true);

    let selected_res_id = reservationIds[roomId];
    let payload = {
      bookingId: bookingId,
      roomId: roomId,
      reservationId: selected_res_id,
      updateType: "REMOVE_GUEST",
      guestType: custCategory,
      updatePricing: "NO",
      setCustomPricing: editPriceCheck,
      updatedPrice: updatedPrice,
    };
    const data = await updateGuestCount(payload)
      .then(() => updateData())
      .then(() => setFalseLoader(false))
      .then(() => toast.success(`${t("Successfully removed guest user")}`))
      .then(() => toast.success(`${t("Successfully updated guest count")}`));
  };

  const [enabledEmail, setenabledEmail] = useState(
    datas !== null &&
      JSON.parse(
        data?.accessControl?.user_feature_map
          ?.CustomerInformationCaptureAndDisplay
      ).read === "YES" &&
      !datas?.email?.includes("example") &&
      datas?.email !== ""
  );
  const [enabledPhone, setenabledPhone] = useState(
    datas !== null &&
      JSON.parse(
        data?.accessControl?.user_feature_map
          ?.CustomerInformationCaptureAndDisplay
      ).read === "YES" &&
      datas?.contact !== "0000000000" &&
      datas?.contact !== ""
  );

  const checkinBooking = () => {
    handleSpringDataRequest(
      `core/api/v1/reservation/update-guest-status?bookingId=${bookingId}&reservationId=${selectedUserResId}&email=${custEmail}&status=ADMIN_CONFIRMED`
    )
      .then((res) => {
        toast.success("Successfully checked in");
        updateInvoice();
      })
      .catch(`${t("Something went wrong")}`);
  };

  const checkoutBooking = () => {
    handleSpringDataRequest(
      `core/api/v1/reservation/update-guest-status?bookingId=${bookingId}&reservationId=${selectedUserResId}&email=${custEmail}&status=CHECKED_OUT`
    )
      .then((res) => {
        toast.success(`${t("Successfully checked out")}`);
        updateInvoice();
      })
      .catch(`${t("Something went wrong")}`);
  };

  const [showCheckinButton, setshowCheckinButton] = useState(false);

  useEffect(() => {
    handleSpringDataRequest(
      `core/api/v1/nightAudit/get-night-audit-flag?currentDate=${moment(
        invoiceData.invoice.actual_checkin.replace("T", " "),
        "YYYY-MM-DD HH:mm:ss"
      )
        .subtract(1, "days")
        .format("DD-MM-YYYY")}&opType=WALK_IN`
    )
      .then((res) => {
        if (
          data?.accessControl?.ADMINRIGHTS === "ADMIN" ||
          data?.accessControl?.ADMINRIGHTS === "SUBADMIN"
        ) {
          setshowCheckinButton(true);
        } else {
          setshowCheckinButton(res);
        }
      })
      .catch((err) => console.log(err));
  }, [invoiceData.invoice.actual_checkin]);

  const [hideCheckinForUnassigned, sethideCheckinForUnassigned] =
    useState(false);

  useEffect(() => {
    if (hotelType !== "ISHA") {
      sethideCheckinForUnassigned(
        invoiceData.invoice.confirmed_room_ids_list.includes("UNASSIGNED")
      );
    }
  }, [invoiceData]);

  const handleDobKeyDown = (event) => {
    if (event.key !== "Tab") {
      event.preventDefault();
    }
  };

  useEffect(() => {
    getAllCtaData();
  }, []);

  const getAllCtaData = async () => {
    try {
      const data = await getAllCTA();
      setCTAData(data);
    } catch (e) {
      console.error(e);
    }
  };

  const checkIfDoNotRented = () => {
    handleSpringDataRequest(
      `core/api/v1/do-not-rent/get-by-idNumber?idNumber=${govIdNum}`
    )
      .then((res) => {
        setDoNotRentData(res);
        setSeverity(res?.[0]?.severity || "HIGH");

        setDnrReason(res?.[0]?.reason || "");
      })
      .catch(() => {});
  };
  useEffect(() => {
    if (!govIdNum) {
      setDoNotRentData([]);
      return;
    }
    const startUpdating = setTimeout(() => checkIfDoNotRented(), 500);
    return () => {
      clearTimeout(startUpdating);
    };
  }, [govIdNum]);

  useEffect(() => {
    if (doNotRentData[0]?.do_not_rent === "YES") {
      setIsDnr(true);
    } else {
      setIsDnr(false);
    }
  }, [doNotRentData]);

  return (
    <div className="custInformationWrapper">
      <div>
        {hotel?.hotelCurrency === "USD" && (
          <>
            {hotel?.accessControl?.hotel?.enable_id_scanner === "AMBIRSCAN" && (
              <Button
                variant="custom-button"
                style={{
                  marginRight: "1rem",
                  float: "right",
                }}
                disabled={loading}
                onClick={ScannedData}
              >
                {loading ? (
                  <CircularProgress
                    size={15}
                    color="inherit"
                    sx={{ ml: 1.5 }}
                  />
                ) : (
                  `${t("Scan id")}`
                )}
              </Button>
            )}

            {hotel?.accessControl?.hotel?.enable_id_scanner === "IDGURU" && (
              <Button
                variant="custom-button"
                onClick={handleOpenIdGuruModal}
                style={{
                  marginRight: "1rem",
                  float: "right",
                }}
              >
                {" "}
                ID Guru scanner
              </Button>
            )}

            {hotel?.accessControl?.hotel?.enable_id_scanner ===
              AI_SCANNERS.AMBIRSCAN_WC && (
              <Button
                variant="custom-button"
                style={{
                  marginRight: "1rem",
                  float: "right",
                }}
                disabled={isWebConnectScanning}
                onClick={startWebConnectScan}
              >
                {isWebConnectScanning
                  ? "Scanning…"
                  : `${t("Scan id")}`}
              </Button>
            )}
          </>
        )}
      </div>
      <form className="customerInfoForm">
        <Grid container paddingTop={2}>
          {emailId !== oldEmail && datas !== null && (
            //Displaying this option only if the customer is not already primary
            <Grid
              container
              rowSpacin={3}
              columnSpacing={2}
              style={{ paddingBottom: "2rem" }}
            >
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Checkbox
                  checked={primaryCheck}
                  onChange={() => {
                    setPrimaryCheck(!primaryCheck);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
                <FormControlLabel
                  style={{
                    marginLeft: "1px",
                    marginTop: "3px",
                    marginBottom: "3px",
                  }}
                  control={<></>}
                  label={t(`Set as primary customer`)}
                ></FormControlLabel>
              </Grid>
            </Grid>
          )}
          <Grid
            container
            rowSpacing={3}
            columnSpacing={2}
            style={{ paddingTop: "0px" }}
          >
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                name="custName"
                id="outlined-name"
                label={t("Customer name")}
                // onBlur={deFocusName}
                autoComplete="new-password"
                onChange={(e) => setCustName(e.target.value)}
                value={custName}
                disabled={
                  JSON.parse(
                    data?.accessControl?.user_feature_map
                      ?.CustomerInformationCaptureAndDisplay
                  ).read === "YES" && datas !== null
                }
                multiline
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <div
                className="position-absolute"
                style={{ top: "4.5rem", zIndex: "10000" }}
              >
                {customerNameData?.length > 0 && showData && (
                  <Card
                    style={{
                      width: "22rem",
                      height: "60%",
                      overflowY: "yes",
                      zIndex: "1000",
                    }}
                  >
                    <IconButton
                      // style={{
                      //   display: "block",
                      //   marginLeft: "auto",
                      //   marginRight: "1rem",
                      // }}
                      color="primary"
                    >
                      <CancelIcon onClick={() => emptyValues()} />
                    </IconButton>
                  </Card>
                )}
                {customerNameData?.length > 0 &&
                  showData &&
                  customerNameData?.map((item, index) => (
                    <Card
                      style={{
                        width: "22rem",
                        height: "60%",
                        overflowY: "yes",
                        zIndex: "1000",
                      }}
                      onClick={() => populateCustomerFeilds(item)}
                    >
                      <CardContent style={{ padding: "3%" }}>
                        <div className="d-flex flex-column">
                          {/* <BsSearch className="mb-0 mr-2" /> */}
                          <div className="d-flex ">
                            <h4 className="mb-0 mr-4">{item.name}</h4>
                            {item.donotRent === "YES" && (
                              <>
                                <p className="badge badge-danger">
                                  {t("Do not rent")}
                                </p>
                                {item?.severity === "LOW" && (
                                  <p className="badge badge-info ml-2">
                                    {" "}
                                    {t("LOW")}
                                  </p>
                                )}
                                {item?.severity === "MEDIUM" && (
                                  <p className="badge badge-warning ml-2">
                                    {t("MEDIUM")}
                                  </p>
                                )}
                                {item?.severity === "HIGH" && (
                                  <p className="badge badge-dark ml-2">
                                    {" "}
                                    {t("HIGH")}
                                  </p>
                                )}
                                {item?.severity === "BLACKLIST" && (
                                  <p className="badge badge-danger ml-2">
                                    {t("BLACKLIST")}
                                  </p>
                                )}
                              </>
                            )}
                          </div>
                          <div className="d-flex mb-0">
                            <p className="mr-3" style={{ fontSize: "13px" }}>
                              {item.email}
                            </p>
                            <p style={{ fontSize: "13px" }}>{item.contact}</p>
                          </div>
                          <p className="mb-0">{item.notes}</p>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
              </div>
            </Grid>
            {(datas === null ||
              (subUser?.toLowerCase() === "subuser" &&
                JSON.parse(
                  data?.accessControl?.user_feature_map?.ResGridCustomerEmail
                ).read !== "YES") ||
              subUser?.toLowerCase() === "admin") && (
              <Grid item xs={12} sm={12} lg={6} xl={6}>
                <TextField
                  name="custEmail"
                  id="standard-multiline-flexible"
                  label={t("Customer email")}
                  // onBlur={deFocusEmail}
                  onChange={(e) => {
                    setCustEmail(e.target.value);
                  }}
                  value={custEmail}
                  autoComplete="new-password"
                  multiline
                  disabled={enabledEmail}
                  type="email"
                  sx={{ width: "100%" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={custEmail?.length > 0 && !validateEmail(custEmail)}
                  helperText={
                    custEmail?.length > 0 && !validateEmail(custEmail)
                      ? "Please enter valid email"
                      : ""
                  }
                />
                <div
                  className="position-absolute"
                  style={{ top: "4.5rem", zIndex: "10000" }}
                >
                  {customerEmailData?.length > 0 && showData && (
                    <Card
                      style={{
                        width: "22rem",
                        height: "60%",
                        overflowY: "yes",
                        zIndex: "1000",
                      }}
                    >
                      <IconButton
                        // style={{
                        //   display: "block",
                        //   marginLeft: "auto",
                        //   marginRight: "1rem",
                        // }}
                        color="primary"
                      >
                        <CancelIcon onClick={() => emptyValues()} />
                      </IconButton>
                    </Card>
                  )}
                  {customerEmailData?.length > 0 &&
                    showData &&
                    customerEmailData?.map((item, index) => (
                      <Card
                        style={{
                          width: "22rem",
                          height: "60%",
                          overflowY: "yes",
                          zIndex: "1000",
                        }}
                        onClick={() => populateCustomerFeilds(item)}
                      >
                        <CardContent style={{ padding: "3%" }}>
                          <div className="d-flex flex-column">
                            {/* <BsSearch className="mb-0 mr-2" /> */}
                            <div className="d-flex ">
                              <h4 className="mb-0 mr-4">{item.name}</h4>
                              {item.donotRent === "YES" && (
                                <>
                                  <p className="badge badge-danger">
                                    {t("Do not rent")}
                                  </p>
                                  {item?.severity === "LOW" && (
                                    <p className="badge badge-info ml-2">
                                      {" "}
                                      {t("LOW")}
                                    </p>
                                  )}
                                  {item?.severity === "MEDIUM" && (
                                    <p className="badge badge-warning ml-2">
                                      {t("MEDIUM")}
                                    </p>
                                  )}
                                  {item?.severity === "HIGH" && (
                                    <p className="badge badge-dark ml-2">
                                      {t("HIGH")}
                                    </p>
                                  )}
                                  {item?.severity === "BLACKLIST" && (
                                    <p className="badge badge-danger ml-2">
                                      {t("BLACKLIST")}
                                    </p>
                                  )}
                                </>
                              )}
                            </div>
                            <div className="d-flex mb-0">
                              <p className="mr-3" style={{ fontSize: "13px" }}>
                                {item.email}
                              </p>
                              <p style={{ fontSize: "13px" }}>{item.contact}</p>
                            </div>
                            <p className="mb-0">{item.notes}</p>
                          </div>
                        </CardContent>
                      </Card>
                    ))}
                </div>
              </Grid>
            )}
            {(datas === null ||
              (subUser?.toLowerCase() === "subuser" &&
                JSON.parse(
                  data?.accessControl?.user_feature_map?.ResGridCustomerPhone
                ).read !== "YES") ||
              subUser?.toLowerCase() === "admin") && (
              <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                <TextField
                  name="custContact"
                  id="outlined-name"
                  // onBlur={deFocusPhone}
                  autoComplete="new-password"
                  label={t("Customer contact")}
                  disabled={enabledPhone}
                  onChange={(e) => {
                    setCustContact(e.target.value);
                  }}
                  value={custContact}
                  type="text"
                  sx={{ width: "100%" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={
                    custContact?.length > 0 && !validatePhoneNumber(custContact)
                  }
                  helperText={
                    custContact?.length > 0 && !validatePhoneNumber(custContact)
                      ? "Please enter valid contact"
                      : ""
                  }
                />

                <div
                  className="position-absolute"
                  style={{ top: "4.5rem", zIndex: "10000" }}
                >
                  {customerPhoneData?.length > 0 && showData && (
                    <Card
                      style={{
                        width: "15rem",
                        height: "60%",
                        overflowY: "yes",
                        zIndex: "1000",
                      }}
                    >
                      <IconButton
                        // style={{
                        //   display: "block",
                        //   marginLeft: "auto",
                        //   marginRight: "1rem",
                        // }}
                        color="primary"
                      >
                        <CancelIcon onClick={() => emptyValues()} />
                      </IconButton>
                    </Card>
                  )}
                  {customerPhoneData?.length > 0 &&
                    showData &&
                    customerPhoneData?.map((item, index) => (
                      <Card
                        style={{
                          width: "15rem",
                          height: "60%",
                          overflowY: "yes",
                          zIndex: "1000",
                        }}
                        onClick={() => populateCustomerFeilds(item)}
                      >
                        <CardContent style={{ padding: "3%" }}>
                          <div className="d-flex flex-column">
                            {/* <BsSearch className="mb-0 mr-2" /> */}
                            <div className="d-flex ">
                              <h4 className="mb-0 mr-4">{item.name}</h4>
                              {item.donotRent === "YES" && (
                                <>
                                  <p className="badge badge-danger">
                                    {t("Do not rent")}
                                  </p>
                                  {item?.severity === "LOW" && (
                                    <p className="badge badge-info ml-2">
                                      {" "}
                                      {t("LOW")}
                                    </p>
                                  )}
                                  {item?.severity === "MEDIUM" && (
                                    <p className="badge badge-warning ml-2">
                                      {t("MEDIUM")}
                                    </p>
                                  )}
                                  {item?.severity === "HIGH" && (
                                    <p className="badge badge-dark ml-2">
                                      {t("HIGH")}
                                    </p>
                                  )}
                                  {item?.severity === "BLACKLIST" && (
                                    <p className="badge badge-danger ml-2">
                                      {t("BLACKLIST")}
                                    </p>
                                  )}
                                </>
                              )}
                            </div>
                            <div className="d-flex mb-0">
                              <p className="mr-3" style={{ fontSize: "13px" }}>
                                {item.email}
                              </p>
                              <p style={{ fontSize: "13px" }}>{item.contact}</p>
                            </div>
                            <p className="mb-0">{item.notes}</p>
                          </div>
                        </CardContent>
                      </Card>
                    ))}
                </div>
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
              <TextField
                select
                className="position-relative"
                name="custGender"
                id="custGender"
                fullWidth
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder={t("Gender")}
                value={custGender}
                onChange={(e) => {
                  setCustGender(e.target.value);
                }}
                label={t("Gender")}
                variant="outlined"
                error={checkIshaUSAccess(data?.emailId) && custGender == "-"}
                helperText={
                  checkIshaUSAccess(data?.emailId) && custGender == "-"
                    ? "Please select gender"
                    : ""
                }
              >
                {hotelType === "ISHA"
                  ? ishaGenderList.map((genVal) => {
                      return (
                        <MenuItem key={genVal} value={genVal}>
                          {genVal}
                        </MenuItem>
                      );
                    })
                  : genderList.map((genVal) => {
                      return (
                        <MenuItem key={genVal} value={genVal}>
                          {genVal}
                        </MenuItem>
                      );
                    })}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
              <TextField
                select
                className="position-relative"
                name="custCategory"
                id="custCategory"
                fullWidth
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder={t("Guest category")}
                value={custCategory}
                onChange={(e) => {
                  setCustCategory(e.target.value);
                }}
                label={t("Guest category")}
                variant="outlined"
              >
                <MenuItem key={"ADULT"} value={"ADULT"}>
                  {t("Adult")}
                </MenuItem>
                <MenuItem key={"CHILD"} value={"CHILD"}>
                  {t("Child")}
                </MenuItem>
                <MenuItem key={"INFANT"} value={"INFANT"}>
                  {t("Infant")}
                </MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat={dateFnsFormat}
                  fullWidth
                  disableMaskedInput
                  mask="___ ___, ____"
                  id="customer_dob"
                  name="customer_dob"
                  value={custDOB}
                  label={t("Date of Birth")}
                  InputProps={{ onKeyDown: handleDobKeyDown }}
                  onChange={setDateOfBirthSelection}
                  sx={{ width: "100%" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  renderInput={(params) => {
                    params.error = false;
                    return (
                      <TextField
                        required
                        fullWidth
                        {...params}
                        sx={{ width: "100%" }}
                      />
                    );
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              {hotelType === "ISHA" &&
              custAddressLine1?.length < 12 &&
              custEmail == emailId ? (
                <>
                  <TextField
                    error
                    name="custAddressLine1"
                    id="outlined-name"
                    label={t("Address")}
                    onChange={(e) => setCustAddressLine1(e.target.value)}
                    value={custAddressLine1}
                    multiline
                    sx={{ width: "100%" }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    helperText={t("Address length is minimum 12 characters")}
                  />
                </>
              ) : (
                <>
                  <TextField
                    name="custAddressLine1"
                    id="outlined-name"
                    label={t("Address")}
                    onChange={(e) => setCustAddressLine1(e.target.value)}
                    value={custAddressLine1}
                    multiline
                    sx={{ width: "100%" }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                name="custAddressLine2"
                id="outlined-name"
                placeholder={t("Address Line 2")}
                onChange={(e) => setCustAddressLine2(e.target.value)}
                value={custAddressLine2}
                multiline
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
              <TextField
                name="custAddressCity"
                id="outlined-name"
                label={t("City")}
                onChange={(e) => setCustAddressCity(e.target.value)}
                value={custAddressCity}
                multiline
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
              {/* <TextField
                name="custAddressState"
                id="outlined-name"
                label={t("State")}
                onChange={(e) => setCustState(e.target.value)}
                value={custState}
                multiline
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              /> */}

              {custCountry !== undefined &&
                Object.entries(countries).length > 0 && (
                  <Autocomplete
                    fullWidth
                    // size="small"
                    renderInput={(params) => {
                      params.inputProps.autoComplete = "new-password";
                      return (
                        <TextField
                          size="small"
                          {...params}
                          label={t("State")}
                        />
                      );
                    }}
                    onChange={(eve, val) => {
                      setCustState(val);
                    }}
                    options={
                      isNull(custCountry) || isUndefined(countries[custCountry])
                        ? []
                        : countries[custCountry]
                    }
                    value={custState}
                    filterOptions={(options, { inputValue }) => {
                      if (!inputValue) return options;
                      const input = inputValue.toLowerCase();
                      return options
                        .filter((option) =>
                          option.toLowerCase().includes(input)
                        )
                        .sort((a, b) => {
                          const aStartsWith = a.toLowerCase().startsWith(input);
                          const bStartsWith = b.toLowerCase().startsWith(input);
                          if (aStartsWith && !bStartsWith) return -1;
                          if (!aStartsWith && bStartsWith) return 1;
                          return a.localeCompare(b);
                        });
                    }}
                  ></Autocomplete>
                )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
              {custCountry !== undefined && (
                <Autocomplete
                  fullWidth
                  autoComplete={false}
                  onChange={(eve, val) => {
                    // if (val !== custCountry) formik.setFieldValue("state", null);
                    setCustCountry(val);
                  }}
                  options={Object.keys(countries)}
                  value={custCountry}
                  renderInput={(params) => {
                    return <TextField {...params} label={t("Country")} />;
                  }}
                />
              )}
            </Grid>
            <Grid item xs={4}>
              <TextField
                name="custAddressZip"
                id="outlined-name"
                label={t("Zipcode")}
                onChange={(e) => {
                  const re = /^[0-9A-Za-z\b]+$/;
                  if (e.target.value == "" || re.test(e.target.value)) {
                    setCustAddressZip(e.target.value);
                    if (
                      e.target.value.length >= 5 &&
                      e.target.value.length <= 10
                    ) {
                      //call the api function and get the city state and country vals
                      getGeoCodeValues(e.target.value);
                    }
                  }
                }}
                value={custAddressZip}
                multiline
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                fullWidth
                renderInput={(params) => {
                  params.inputProps.autoComplete = "new-password";
                  return <TextField {...params} label={t("Nationality")} />;
                }}
                onChange={(eve, val) => {
                  setCustNationality(val);
                }}
                options={nationalities}
                // options={
                //   isNull(formik.values.nationality) ||
                //   isUndefined(countries[formik.values.country])
                //     ? []
                //     : countries[formik.values.country]
                // }
                value={custNationality}
              ></Autocomplete>
            </Grid>
            <Grid item xs={4}>
              <TextField
                name="custOccupation"
                id="outlined-name"
                label={t("Occupation")}
                value={custOccupation}
                onChange={(e) => setCustOccupation(e.target.value)}
                multiline
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            {JSON.parse(
              data?.accessControl?.user_feature_map?.IshaExtraGuestDetails
            ).read === "YES" &&
              (checkIshaAccess(data?.emailId) ||
                checkIshaUSAccess(data?.emailId)) && (
                <>
                  {custEmail == emailId ? (
                    <>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <TextField
                          name="company_name"
                          id="company_name"
                          fullWidth
                          type="text"
                          placeholder={t("Company Name")}
                          value={custCompany}
                          onChange={(e) => setCustCompany(e.target.value)}
                          label={t("Company Name")}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <TextField
                          name="emergency_contact_name"
                          id="emergency_contact_name"
                          fullWidth
                          type="text"
                          required
                          placeholder={t("Emergency Contact Name")}
                          value={custEmergencyName}
                          onChange={(e) => setCustEmergencyName(e.target.value)}
                          label={t("Emergency Contact Name")}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        {custEmergency == custContact ? (
                          <TextField
                            name="emergency_contact"
                            id="emergency_contact"
                            fullWidth
                            type="text"
                            placeholder={t("Emergency Contact")}
                            value={custEmergency}
                            onChange={(e) => setCustEmergency(e.target.value)}
                            error
                            required
                            helperText={t("Enter different number")}
                            label={t("Emergency Contact")}
                            variant="outlined"
                          />
                        ) : (
                          <TextField
                            name="emergency_contact"
                            id="emergency_contact"
                            fullWidth
                            type="text"
                            required
                            placeholder={t("Emergency Contact")}
                            value={custEmergency}
                            onChange={(e) => setCustEmergency(e.target.value)}
                            label={t("Emergency Contact")}
                            variant="outlined"
                            error={
                              custEmergency?.length > 0 &&
                              !validatePhoneNumber(custEmergency)
                            }
                            helperText={
                              custEmergency?.length > 0 &&
                              !validatePhoneNumber(custEmergency)
                                ? "Please enter valid contact"
                                : ""
                            }
                          />
                        )}
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                        <TextField
                          name="company_name"
                          id="company_name"
                          fullWidth
                          type="text"
                          placeholder={t("Company Name")}
                          value={custCompany}
                          onChange={(e) => setCustCompany(e.target.value)}
                          label={t("Company Name")}
                          variant="outlined"
                        />
                      </Grid>
                      {custRelation === "Other" ? (
                        <>
                          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                            <TextField
                              select
                              id="relationship_with_primary"
                              label={t("Relationship With Primary")}
                              name="relationship_with_primary"
                              value={custRelation}
                              onChange={(e) => setCustRelation(e.target.value)}
                              fullWidth
                            >
                              {ishaRelationWithPrimary?.length > 0 &&
                                ishaRelationWithPrimary.map(
                                  (relation, index) => {
                                    return (
                                      <MenuItem key={relation} value={relation}>
                                        {relation}
                                      </MenuItem>
                                    );
                                  }
                                )}
                            </TextField>
                          </Grid>
                          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                            <TextField
                              name="custOtherRelation"
                              id="outlined-name"
                              label={t("Other relationship to primary")}
                              onChange={(e) =>
                                setCustOtherRelation(e.target.value)
                              }
                              value={custOtherRelation}
                              multiline
                              sx={{ width: "100%" }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                        </>
                      ) : (
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                          <TextField
                            select
                            id="relationship_with_primary"
                            label={t("Relationship With Primary")}
                            name="relationship_with_primary"
                            value={custRelation}
                            onChange={(e) => setCustRelation(e.target.value)}
                            fullWidth
                          >
                            {ishaRelationWithPrimary?.length > 0 &&
                              ishaRelationWithPrimary.map((relation, index) => {
                                return (
                                  <MenuItem key={relation} value={relation}>
                                    {relation}
                                  </MenuItem>
                                );
                              })}
                          </TextField>
                        </Grid>
                      )}
                    </>
                  )}
                  <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <TextField
                      select
                      name="purposeOfVisit"
                      id="purposeOfVisit"
                      fullWidth
                      placeholder={t("Purpose of visit")}
                      value={custPurpose}
                      onChange={(e) => setCustPurpose(e.target.value)}
                      label={t("Purpose of visit")}
                      variant="outlined"
                    >
                      {ishaPurposeOfVisit?.length > 0 &&
                        ishaPurposeOfVisit.map((purpose, index) => {
                          return (
                            <MenuItem key={purpose} value={purpose}>
                              {purpose}
                            </MenuItem>
                          );
                        })}
                    </TextField>
                  </Grid>
                  {checkIshaUSAccess(data?.emailId) && (
                    <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        name="event_type"
                        id="event_type"
                        fullWidth
                        type="text"
                        placeholder={t("Event Name")}
                        value={custEventType}
                        onChange={(e) => setCustEventType(e.target.value)}
                        label={t("Event Name")}
                        variant="outlined"
                      />
                    </Grid>
                  )}
                  {checkIshaAccess(data?.emailId) && (
                    <>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <FormControl>
                          <InputLabel id="demo-simple-select-label">
                            {t("Programs Attended")}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            name="programsAttended"
                            id="programsAttended"
                            label={t("Programs Attended")}
                            value={selectedPrograms}
                            onChange={handleProgramChange}
                            required="true"
                            multiple
                            style={{ width: "17.3rem" }}
                            // disabled={
                            //   custPurpose == "Program Participation" ? false : true
                            // }
                            // MenuProps={MenuProps}
                            placeholder={t("Choose Programs Attended")}
                          >
                            {ishaProgramsAttended?.length > 0 &&
                              ishaProgramsAttended.map((program, index) => {
                                return (
                                  <MenuItem key={program} value={program}>
                                    {program}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <TextField
                          select
                          className="position-relative"
                          name="ocoCheckinComplete"
                          id="ocoCheckinComplete"
                          fullWidth
                          placeholder="OCO checkin complete"
                          value={custOCO}
                          onChange={(e) => {
                            setCustOCO(e.target.value);
                          }}
                          label="OCO checkin complete"
                          variant="outlined"
                        >
                          <MenuItem key={"Yes"} value={"Yes"}>
                            {"Yes"}
                          </MenuItem>
                          <MenuItem key={"No"} value={"No"}>
                            {"No"}
                          </MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <TimePicker
                            style={{ width: "17.3rem" }}
                            label={t("Estimated time of arrival")}
                            name="customer_eta"
                            id="customer_eta"
                            value={custETA}
                            onChange={handleETAChange}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                style={{ width: "17.3rem" }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <TimePicker
                            style={{ width: "17.3rem" }}
                            label={t("Estimated time of departure")}
                            name="customer_etd"
                            id="customer_etd"
                            value={custETD}
                            onChange={handleETDChange}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                style={{ width: "17.3rem" }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <TextField
                          name="approvedByOverseas"
                          id="approvedByOverseas"
                          select
                          className="position-relative"
                          fullWidth
                          type="text"
                          placeholder="Approved by overseas"
                          value={custApprovedOverseas}
                          onChange={(e) => {
                            setCustApprovedOverseas(e.target.value);
                          }}
                          label="Approved by overseas"
                          variant="outlined"
                        >
                          {ishaApprovedByOverseas?.length > 0 &&
                            ishaApprovedByOverseas.map((purpose, index) => {
                              return (
                                <MenuItem key={purpose} value={purpose}>
                                  {purpose}
                                </MenuItem>
                              );
                            })}
                        </TextField>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <TextField
                      name="medicalCondition"
                      id="medicalCondition"
                      select
                      className="position-relative"
                      fullWidth
                      type="text"
                      placeholder={t("Medical condition")}
                      value={custMedicalCondition}
                      onChange={(e) => {
                        setCustMedicalCondition(e.target.value);
                      }}
                      label={t("Medical condition")}
                      variant="outlined"
                      disabled={true}
                    >
                      <MenuItem key={"Yes"} value={"Yes"}>
                        {"Yes"}
                      </MenuItem>
                      <MenuItem key={"No"} value={"No"}>
                        {"No"}
                      </MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <FormControl
                      fullWidth
                      // sx={{ width: "12rem", marginLeft: "2rem" }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        {t("Upload Passport Size Photo")}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={passportImageUpload}
                        onChange={(e) => setPassportImageUpload(e.target.value)}
                        label={t("Upload Passport Size Photo")}
                      >
                        <MenuItem value={"Device"}>
                          {" "}
                          {t("Device upload")}
                        </MenuItem>
                        <MenuItem value={"Camera"}>
                          {" "}
                          {t("Camera upload")}{" "}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    {passportImageUpload === "Camera" && (
                      <div className="mt-2 d-flex">
                        <div className="d-flex flex-column mr-3">
                          {passportImage !== undefined && (
                            <img
                              src={`${passportImage}`}
                              style={{
                                width: "24rem",
                                heigth: "20rem",
                                borderRadius: "1rem",
                              }}
                            />
                          )}
                          <Button
                            variant="custom-button"
                            className="mr-2 mt-3"
                            onClick={() => handleOpenPassportModal()}
                          >
                            {t("Upload Passport Size Photo")}
                          </Button>
                        </div>
                      </div>
                    )}
                  </Grid>
                  {passportImageUpload === "Device" && (
                    <Grid item xs={12}>
                      <div className="d-flex">
                        <div className="d-flex flex-column mr-4 mt-3 mb-3 w-50">
                          <h5 className="mb-3" style={{ marginRight: "13px" }}>
                            {t("Passport Size Photo")}
                          </h5>
                          <ReactImageUploading
                            value={passportImages}
                            onChange={(image) => {
                              setPassportImages(image);
                            }}
                            dataURLKey="data_url"
                          >
                            {({
                              imageList,
                              onImageUpload,
                              onImageUpdate,
                              onImageRemove,
                              isDragging,
                              dragProps,
                            }) => (
                              // write your building UI
                              <Stack
                                // p="2"
                                // bgColor="gray.50"
                                // borderRadius="lg"
                                className="upload__image-wrapper"
                                sx={{
                                  borderRadius: "10px",
                                  height: "150px",
                                  backgroundColor: "#d3d3d336",
                                  padding: "1rem",
                                }}
                              >
                                {imageList.length === 0 && (
                                  <IconButton
                                    children={
                                      <UploadIcon
                                        icon="bi:upload"
                                        htmlColor="black"
                                      />
                                    }
                                    variant="outline"
                                    // height="100%"
                                    sx={{
                                      borderRadius: "20px",
                                      backgroundColor: "#d3d3d3",
                                      height: "100%",
                                    }}
                                    onClick={onImageUpload}
                                    {...dragProps}
                                  ></IconButton>
                                )}
                                <Stack spacing="2">
                                  {imageList.map((image, index) => (
                                    <Stack
                                      sx={{
                                        position: "relative",
                                        padding: "0.5rem",
                                      }}
                                      key={index}
                                    >
                                      <img
                                        src={
                                          image["data_url"].includes("base64")
                                            ? image["data_url"]
                                            : image["data_url"] +
                                              "?lastmod=" +
                                              format(
                                                new Date(),
                                                "ddMMyyyyhhmmsstt"
                                              )
                                        }
                                        style={{
                                          height: "125px",
                                          width: "100%",
                                          borderRadius: "1rem",
                                          boxShadow: "md",
                                          border: "1px solid",
                                          borderColor: "gray.200",
                                        }}
                                        onClick={() =>
                                          handleFrontImagePopupShow("front")
                                        }
                                        alt=""
                                      />

                                      <IconButton
                                        children={
                                          <CloseIcon
                                            fontSize="xs"
                                            htmlColor="black"
                                          />
                                        }
                                        size="xs"
                                        sx={{
                                          position: "absolute",
                                          borderRadius: "100%",
                                          backgroundColor: "white",
                                          top: "0",
                                          // colorScheme="teal"
                                          marginTop: "0px !important",
                                          left: "0",
                                          "&:hover": {
                                            color: "black",
                                            backgroundColor: "#ffffffcc",
                                          },
                                        }}
                                        onClick={() => {
                                          onImageRemove(index);
                                          deleteHotelLogo("passport");
                                        }}
                                      />
                                      <IconButton
                                        children={
                                          <ChangeCircleIcon
                                            fontSize="xs"
                                            htmlColor="black"
                                          />
                                        }
                                        size="xs"
                                        sx={{
                                          position: "absolute",
                                          borderRadius: "100%",
                                          top: "0",
                                          backgroundColor: "white",
                                          // colorScheme="teal"
                                          marginTop: "0px !important",
                                          right: "0",
                                          "&:hover": {
                                            color: "black",
                                            backgroundColor: "#ffffffcc",
                                          },
                                        }}
                                        onClick={() => onImageUpdate(index)}
                                      />
                                    </Stack>
                                  ))}
                                </Stack>
                              </Stack>
                            )}
                          </ReactImageUploading>
                        </div>
                      </div>
                    </Grid>
                  )}
                </>
              )}
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {t("Government id type")}
                </InputLabel>
                <Select
                  name="govt_id_type"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={govIdType}
                  defaultValue={govIdType}
                  label={t("Government id type")}
                  onChange={(e) => setGovIdType(e.target.value)}
                  sx={{ width: "100%" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  {hotel.hotelCurrency === "INR"
                    ? govIdIndia.map((item) => (
                        <MenuItem value={item}>{item}</MenuItem>
                      ))
                    : govIdUS.map((item) => (
                        <MenuItem value={item}>{item}</MenuItem>
                      ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <TextField
                name="govt_id_number"
                id="outlined-name"
                label={t("Govt ID Number")}
                onChange={(e) => setGovIdNum(e.target.value)}
                value={govIdNum}
                multiline
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
                error={
                  doNotRentData?.[0]?.do_not_rent === "YES" &&
                  datas?.govt_id_value !== govIdNum
                }
                helperText={
                  doNotRentData?.[0]?.reason &&
                  datas?.govt_id_value !== govIdNum
                    ? doNotRentData?.[0]?.reason
                    : ""
                }
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  {t("Upload Image")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={imageUpload}
                  onChange={(e) => setimageUpload(e.target.value)}
                  label={t("Upload Image")}
                >
                  <MenuItem value={"Device"}>{t("Device upload")}</MenuItem>
                  <MenuItem value={"Camera"}>{t("Camera upload")} </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <FormControl fullWidth sx={{ width: 325 }}>
                <InputLabel id="demo-simple-select-label">
                  {t("Room No.(s)")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={roomId}
                  label={t("Room No.(s)")}
                  onChange={(e) => setroomId(e.target.value)}
                >
                  {roomIdList &&
                    roomIdList.map((item) => (
                      <MenuItem value={item}>{item}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            {customerNotes?.length > 0 &&
              doNotRentData?.[0]?.do_not_rent === "YES" && (
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <Button
                    style={{
                      height: "2.5rem",
                      background: "#F64E60",
                      color: "#fff",
                      marginLeft: "25%",
                      marginTop: "0.5rem",
                    }}
                    onClick={handleRShow}
                  >
                    {doNotRentLoad ? (
                      <CircularProgress
                        size={15}
                        color="inherit"
                        sx={{ ml: 1.5 }}
                      />
                    ) : (
                      `${t("Remove Do-Not Rent")}`
                    )}
                  </Button>
                </Grid>
              )}
            {datas !== null && (
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Checkbox
                  checked={primaryRoomCustCheck}
                  onChange={() => {
                    setPrimaryRoomCustCheck(!primaryRoomCustCheck);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                  disabled={!allowSetPrimaryCustCheck}
                />
                <FormControlLabel
                  style={{
                    marginLeft: "1px",
                    marginTop: "3px",
                    marginBottom: "3px",
                  }}
                  disabled={!allowSetPrimaryCustCheck}
                  control={<></>}
                  label={
                    !allowSetPrimaryCustCheck
                      ? t(`User already primary customer for room: `) + roomId
                      : t(`Set guest as primary guest for room: `) + roomId
                  }
                ></FormControlLabel>
              </Grid>
            )}
          </Grid>
        </Grid>
        {/* <div className="customerInfo">
                    <TextField
                    id="outlined-select-currency"
                    select
                    label="Select Country"
                    value={customerInformationForm.custAddressCountry}
                    onChange={customerInformationForm.handleChange}
                    name="custAddressCountry"
                    sx={{width:325}}

                    >
                    {options.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                        {option.label}
                        </MenuItem>
                    ))}
                    </TextField>
                </div> */}
        {/* <Autocomplete
            id="country-select-demo"
            sx={{ width: 300 }}
            options={countries}
            value={custCountry}
            onChange={(e) => setCustCountry(e.target.value)}
            autoHighlight
            getOptionLabel={(option) => option.label}
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.label}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Choose a country"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password", // disable autocomplete and autofill
                }}

              />
            )}
          /> */}
        <div className="customerInfo w-100">
          {imageUpload === "Camera" && (
            <div className="mt-4 d-flex">
              <div className="d-flex flex-column mr-3">
                {image !== undefined && (
                  <img
                    src={`${image}`}
                    style={{
                      width: "24rem",
                      heigth: "20rem",
                      borderRadius: "1rem",
                    }}
                  />
                )}
                <Button
                  variant="custom-button"
                  className="mr-4 mt-3"
                  onClick={() => handleOpenFrontIdModal()}
                >
                  {t("Upload front id")}
                </Button>
              </div>
              <div className="d-flex flex-column">
                {backImage !== undefined && (
                  <img
                    src={`${backImage}`}
                    style={{
                      width: "24rem",
                      heigth: "20rem",
                      borderRadius: "1rem",
                    }}
                  />
                )}
                <Button
                  variant="custom-button"
                  className="mt-3"
                  onClick={() => handleOpenBackIdModal()}
                >
                  {t("Upload Back id")}
                </Button>
              </div>
            </div>
          )}
          {imageUpload === "Device" && (
            <div className="d-flex p-3 w-100">
              <div className="d-flex flex-column mr-4 mt-3 mb-3 w-50">
                <h5 className="mb-3" style={{ marginRight: "13px" }}>
                  {t("ID front")}
                </h5>
                <ReactImageUploading
                  value={images}
                  onChange={(image) => {
                    setImages(image);
                  }}
                  dataURLKey="data_url"
                >
                  {({
                    imageList,
                    onImageUpload,
                    onImageUpdate,
                    onImageRemove,
                    isDragging,
                    dragProps,
                  }) => (
                    // write your building UI
                    <Stack
                      // p="2"
                      // bgColor="gray.50"
                      // borderRadius="lg"
                      className="upload__image-wrapper"
                      sx={{
                        borderRadius: "10px",
                        height: "150px",
                        backgroundColor: "#d3d3d336",
                        padding: "1rem",
                      }}
                    >
                      {imageList.length === 0 && (
                        <IconButton
                          children={
                            <UploadIcon icon="bi:upload" htmlColor="black" />
                          }
                          variant="outline"
                          // height="100%"
                          sx={{
                            borderRadius: "20px",
                            backgroundColor: "#d3d3d3",
                            height: "100%",
                          }}
                          onClick={onImageUpload}
                          {...dragProps}
                        ></IconButton>
                      )}
                      <Stack spacing="2">
                        {imageList.map((image, index) => (
                          <Stack
                            sx={{ position: "relative", padding: "0.5rem" }}
                            key={index}
                          >
                            <img
                              src={
                                image["data_url"]?.includes("base64")
                                  ? image["data_url"]
                                  : image["data_url"] +
                                    "?lastmod=" +
                                    format(new Date(), "ddMMyyyyhhmmsstt")
                              }
                              style={{
                                height: "125px",
                                width: "100%",
                                borderRadius: "1rem",
                                boxShadow: "md",
                                border: "1px solid",
                                borderColor: "gray.200",
                              }}
                              alt=""
                              onClick={() =>
                                handleModalShow("Front ID", image["data_url"])
                              }
                            />

                            <IconButton
                              children={
                                <CloseIcon fontSize="xs" htmlColor="black" />
                              }
                              size="xs"
                              sx={{
                                position: "absolute",
                                borderRadius: "100%",
                                backgroundColor: "white",
                                top: "0",
                                // colorScheme="teal"
                                marginTop: "0px !important",
                                left: "0",
                                "&:hover": {
                                  color: "black",
                                  backgroundColor: "#ffffffcc",
                                },
                              }}
                              onClick={() => {
                                onImageRemove(index);
                                deleteHotelLogo("front");
                              }}
                            />
                            <IconButton
                              children={
                                <ChangeCircleIcon
                                  fontSize="xs"
                                  htmlColor="black"
                                />
                              }
                              size="xs"
                              sx={{
                                position: "absolute",
                                borderRadius: "100%",
                                top: "0",
                                backgroundColor: "white",
                                // colorScheme="teal"
                                marginTop: "0px !important",
                                right: "0",
                                "&:hover": {
                                  color: "black",
                                  backgroundColor: "#ffffffcc",
                                },
                              }}
                              onClick={() => onImageUpdate(index)}
                            />
                          </Stack>
                        ))}
                      </Stack>
                    </Stack>
                  )}
                </ReactImageUploading>
              </div>
              <div className="d-flex flex-column mr-4 mt-3 mb-3 w-50">
                <h5 className="mb-3">{t("ID back")}</h5>
                <ReactImageUploading
                  value={faviconImages}
                  onChange={(image) => {
                    setFaviconImages(image);
                  }}
                  dataURLKey="data_url"
                >
                  {({
                    imageList,
                    onImageUpload,
                    onImageUpdate,
                    onImageRemove,
                    isDragging,
                    dragProps,
                  }) => (
                    // write your building UI
                    <Stack
                      // p="2"
                      // bgColor="gray.50"
                      // borderRadius="lg"
                      className="upload__image-wrapper"
                      sx={{
                        borderRadius: "10px",
                        height: "150px",
                        backgroundColor: "#d3d3d336",
                        padding: "1rem",
                      }}
                    >
                      {imageList.length === 0 && (
                        <IconButton
                          children={
                            <UploadIcon icon="bi:upload" htmlColor="black" />
                          }
                          variant="outline"
                          sx={{
                            borderRadius: "20px",
                            backgroundColor: "#d3d3d3",
                            height: "100%",
                          }}
                          onClick={onImageUpload}
                          {...dragProps}
                        ></IconButton>
                      )}
                      <Stack spacing="2">
                        {imageList.map((image, index) => (
                          <Stack
                            sx={{ position: "relative", padding: "0.5rem" }}
                            key={index}
                          >
                            <img
                              src={
                                image["data_url"]?.includes("base64")
                                  ? image["data_url"]
                                  : image["data_url"] +
                                    "?lastmod=" +
                                    format(new Date(), "ddMMyyyyhhmmsstt")
                              }
                              style={{
                                height: "125px",
                                width: "100%",
                                borderRadius: "1rem",
                                boxShadow: "md",
                                border: "1px solid",
                                borderColor: "gray.200",
                              }}
                              alt=""
                              onClick={() =>
                                handleModalShow("Back ID", image["data_url"])
                              }
                            />

                            <IconButton
                              children={
                                <CloseIcon fontSize="xs" htmlColor="black" />
                              }
                              size="xs"
                              sx={{
                                position: "absolute",
                                borderRadius: "100%",
                                backgroundColor: "white",
                                top: "0",
                                // colorScheme="teal"
                                marginTop: "0px !important",
                                left: "0",
                                "&:hover": {
                                  color: "black",
                                  backgroundColor: "#ffffffcc",
                                },
                              }}
                              onClick={() => {
                                onImageRemove(index);
                                deleteHotelLogo("back");
                              }}
                            />
                            <IconButton
                              children={
                                <ChangeCircleIcon
                                  fontSize="xs"
                                  htmlColor="black"
                                />
                              }
                              size="xs"
                              sx={{
                                position: "absolute",
                                borderRadius: "100%",
                                top: "0",
                                backgroundColor: "white",
                                // colorScheme="teal"
                                marginTop: "0px !important",
                                right: "0",
                                "&:hover": {
                                  color: "black",
                                  backgroundColor: "#ffffffcc",
                                },
                              }}
                              onClick={() => onImageUpdate(index)}
                            />
                          </Stack>
                        ))}
                      </Stack>
                    </Stack>
                  )}
                </ReactImageUploading>
              </div>
            </div>
          )}
        </div>
        <div className="customerInfo w-100">
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Switch
                    checked={isDnr}
                    onChange={() => setIsDnr((prev) => !prev)}
                  />
                }
                label="Do not Rent"
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  {"Severity"}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Severity}
                  style={{ width: "100%" }}
                  onChange={(e) => setSeverity(e.target.value)}
                  label={"Severity"}
                  disabled={!isDnr}
                  size="small"
                >
                  <MenuItem value={"MEDIUM"}>MEDIUM</MenuItem>
                  <MenuItem value={"HIGH"}>HIGH</MenuItem>
                  <MenuItem value={"BLACKLIST"}>BLACKLIST</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <TextField
                name="dnrReason"
                id="outlined-name"
                label={"Reason for do not rent"}
                onChange={(e) => setDnrReason(e.target.value)}
                value={dnrReason}
                sx={{ width: "100%" }}
                disabled={!isDnr}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                size="small"
              />
            </Grid>
          </Grid>
        </div>
        {isDnr && !govIdNum && (
          <div className="customerInfo w-100">
            <Alert severity="error" sx={{ mb: 2 }}>
              Please enter the government ID number to mark the user as Do Not
              Rent.
            </Alert>
          </div>
        )}
      </form>
      <Modal
        show={pricingUpdateModal}
        onHide={handlePricingUpdateModalClose}
        style={{ zIndex: "3000" }}
      >
        <Modal.Header>
          <Modal.Title>{t("Update Guest Count/Pricing")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Grid container>
            <Grid item xs={12}>
              {`${t("Do you want to update the pricing for Room: ")}` +
                roomId +
                " ?"}
            </Grid>
            {JSON.parse(data?.accessControl?.user_feature_map?.EditBookingPrice)
              .read === "YES" && (
              <Grid item xs={12}>
                <Checkbox
                  checked={editPriceCheck}
                  onChange={() => {
                    setEditPriceCheck(!editPriceCheck);
                  }}
                  style={{ paddingLeft: "0px", paddingRight: "0px" }}
                  inputProps={{ "aria-label": "controlled" }}
                />
                <FormControlLabel
                  style={{
                    marginLeft: "1px",
                    marginTop: "3px",
                    marginBottom: "3px",
                  }}
                  control={<></>}
                  label={`${t("Edit pricing")}`}
                ></FormControlLabel>
              </Grid>
            )}
          </Grid>
          <Grid container rowSpacing={3} columnSpacing={2}>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <TextField
                disabled={true}
                name="Adults"
                id="outlined-name"
                label={t("Adults")}
                onChange={(e) => setUpdatedAdults(e.target.value)}
                value={updatedAdults}
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <TextField
                disabled={true}
                name="Children"
                id="outlined-name"
                label={t("Children")}
                onChange={(e) => setUpdatedChild(e.target.value)}
                value={updatedChild}
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <TextField
                disabled={!editPriceCheck}
                name="updated_price"
                id="outlined-name"
                label={t("Price")}
                onChange={(e) => setUpdatedPrice(e.target.value)}
                value={
                  !editPriceCheck
                    ? Number(updatedPrice).toFixed(2)
                    : updatedPrice
                }
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              if (deleteCustCheck) {
                guestUpdateReduceCountWithoutPricing();
              } else {
                guestUpdateFuncWithoutPricing();
              }
            }}
          >
            {falseLoader ? (
              <CircularProgress size={15} color="inherit" sx={{ ml: 1 }} />
            ) : (
              `${t("NO")}`
            )}
          </Button>
          <Button
            variant="custom-button"
            onClick={() => {
              if (deleteCustCheck) {
                guestUpdateReduceCountWithPricing();
              } else {
                guestUpdateFuncWithPricing();
              }
            }}
          >
            {loading ? (
              <CircularProgress size={15} color="inherit" sx={{ ml: 1 }} />
            ) : (
              `${t("YES")}`
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showFrontImagePopup}
        onHide={handleshowFrontImagePopupClose}
        style={{ zIndex: "3000" }}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body style={{ width: 500, height: 300 }}>
          {showPopUpImages === "front" ? (
            UserImagesData?.frontUrl !== "" ? (
              <img
                src={UserImagesData?.frontUrl}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  resizeMode: "cover",
                }}
              />
            ) : (
              <></>
            )
          ) : UserImagesData?.backUrl !== "" ? (
            <img
              src={UserImagesData?.backUrl}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                resizeMode: "cover",
              }}
            />
          ) : (
            <></>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        show={modalShow}
        onHide={handleModalClose}
        style={{ zIndex: "3000", width: "100%", height: "100%" }}
        dialogClassName={"myModalBodyCTAImg"}
        contentClassName={"myModalContentCTAImg"}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
          <Button
            className="mx-2"
            variant="secondary"
            onClick={() => downloadImage(imgURL)}
          >
            {t("Download")}
          </Button>
        </Modal.Header>
        <Modal.Body>
          <img
            src={imgURL}
            alt=""
            width="100%"
            height="100%"
            style={{ marginRight: "1rem", marginLeft: "0rem" }}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showFrontIdModal}
        onHide={handleCloseFrontIdModal}
        style={{ zIndex: "3000" }}
      >
        <Modal.Header closeButton>{t("Front id")} </Modal.Header>
        <Modal.Body>
          {!image ? (
            <div>
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
              />
            </div>
          ) : (
            <img src={image} alt="test-ilustartion" />
          )}
          <Button
            variant="custom-button"
            onClick={() => (!image ? capture() : setImage(undefined))}
          >
            {!image ? `${t("Capture photo")}` : `${t("take photo")}`}
          </Button>
        </Modal.Body>
      </Modal>

      {/*Passport Image upload Camera Modal*/}
      <Modal
        show={showPassportModal}
        onHide={handleClosePassportModal}
        style={{ zIndex: "3000" }}
      >
        <Modal.Header closeButton> {t("Passport Size Photo")}</Modal.Header>
        <Modal.Body>
          {!passportImage ? (
            <div>
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
              />
            </div>
          ) : (
            <img src={passportImage} alt="test-ilustartion" />
          )}
          <Button
            variant="custom-button"
            onClick={() =>
              !passportImage ? passportCapture() : setPassportImage(undefined)
            }
          >
            {!passportImage ? `${t("Capture photo")}` : `${t("take photo")}`}
          </Button>
        </Modal.Body>
      </Modal>

      <Modal show={dshow} onHide={handleDClose} style={{ zIndex: "3000" }}>
        <Modal.Header closeButton>
          <Modal.Title>
            {t("Do you want to add Donot rent tag to this user")}
          </Modal.Title>
        </Modal.Header>
        <div
          style={{
            marginLeft: "3rem !important",
            marginRight: "3rem !important",
          }}
        >
          <select
            className="form-select form-select-lg ml-4 mr-4"
            size="lg"
            value={Severity}
            onChange={(e) => setSeverity(e.target.value)}
          >
            <option selected value="LOW">
              {t("LOW")}
            </option>
            <option value="MEDIUM"> {t("MEDIUM")}</option>

            <option value="HIGH">{t("HIGH")}</option>
            <option value="BLACKLIST">{t("BLACKLIST")}</option>
          </select>
        </div>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDClose}>
            {t("Close")}
          </Button>
          <Button variant="custom-button" onClick={createDoNotRentStatus}>
            {loading ? (
              <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
            ) : (
              "Save"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={rshow} onHide={handleRClose} style={{ zIndex: "3000" }}>
        <Modal.Header closeButton>
          <Modal.Title>
            {t("Do you want to remove Donot rent tag to this user")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleRClose}>
            {t("Close")}
          </Button>
          <Button variant="custom-button" onClick={removeDoNotRentStatus}>
            {loading ? (
              <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
            ) : (
              `${t("Save")}`
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showBackIdModal}
        onHide={handleCloseBackIdModal}
        style={{ zIndex: "3000" }}
      >
        <Modal.Header closeButton>{t("Back id")}</Modal.Header>

        <Modal.Body>
          {!backImage ? (
            <div>
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
              />
            </div>
          ) : (
            <img src={backImage} alt="test-ilustartion" />
          )}
          <Button
            variant="custom-button"
            onClick={() =>
              !backImage ? backcapture() : setBackImage(undefined)
            }
          >
            {!backImage ? `${t("Capture photo")}` : `${t("take photo")}`}
          </Button>
        </Modal.Body>
      </Modal>

      <div className="customerBtnWrapper">
        <div className="customerBtns">
          {datas === null ? (
            <button className="cancelBtn" onClick={onCancelClick}>
              {t("Cancel")}
            </button>
          ) : (
            <button
              className="saveCustomer"
              style={{
                background: custEmail === emailId ? "#FFADB6" : "#F64E60",
              }}
              disabled={deleteCustLoader || custEmail == emailId}
              title={
                custEmail === emailId
                  ? `${t("Cannot delete primary customer")}`
                  : `${t("Delete customer from booking")}`
              }
              onClick={() => deleteCustomer()}
            >
              {deleteCustLoader ? (
                <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
              ) : (
                `${t("Delete Customer")}`
              )}
            </button>
          )}

          <div>
            {selectedGuestStatus === "CONFIRMED" &&
              JSON.parse(
                data?.accessControl?.user_feature_map?.GuestCheckInCheckOut
              ).read === "YES" &&
              showCheckinButton &&
              !hideCheckinForUnassigned && (
                <Button
                  variant="custom-button"
                  onClick={() => {
                    if (
                      data?.accessControl?.ADMINRIGHTS === "ADMIN" ||
                      data?.accessControl?.ADMINRIGHTS === "SUBADMIN" ||
                      JSON.parse(
                        data?.accessControl?.user_feature_map?.UploadIdToCheckin
                      ).read !== "YES"
                    ) {
                      checkinBooking();
                    } else {
                      handleSpringDataRequest(
                        `core/api/v1/image/get-user-id-images?emailId=${custEmail}`
                      )
                        .then((res) => {
                          if (
                            res.frontUrl === null ||
                            res.frontUrl === undefined ||
                            res.frontUrl === "" ||
                            res.backUrl === "" ||
                            res.backUrl === null ||
                            res.backUrl === undefined
                          ) {
                            toast.warning(
                              `${t("Please add user id images for checkin")}`
                            );
                          } else {
                            checkinBooking();
                          }
                        })
                        .catch((err) => toast.error("Something wrong"));
                    }
                  }}
                  style={{
                    height: "44px",
                    marginTop: "2px",
                    marginLeft: "24rem",
                  }}
                >
                  {t("Guest Check-in")}
                </Button>
              )}
            {selectedGuestStatus === "ADMIN_CONFIRMED" &&
              JSON.parse(
                data?.accessControl?.user_feature_map?.GuestCheckInCheckOut
              ).read === "YES" &&
              balanceDue === 0 &&
              !hideCheckinForUnassigned && (
                <Button
                  onClick={() => checkoutBooking()}
                  variant="custom-button"
                  style={{
                    height: "44px",
                    marginTop: "2px",
                    marginLeft: "24rem",
                  }}
                >
                  {t("Guest Check-out")}
                </Button>
              )}
          </div>
          <button
            className="saveCustomer"
            type="submit"
            disabled={
              editCustLoader ||
              disableSave ||
              (isDnr && !govIdNum) ||
              (hotelType === "ISHA" &&
                custAddressLine1?.length < 12 &&
                custEmail == emailId)
            }
            onClick={() =>
              datas === null ? addCustomerDetails() : updateCustomerDetails()
            }
          >
            {editCustLoader ? (
              <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
            ) : (
              `${t("Save Customer")}`
            )}
          </button>

          {idGuruModal && (
            <IDguru
              show={idGuruModal}
              hide={handleCloseIdGuruModal}
              setselectedUserIdGuruData={setselectedUserIdGuruData}
            />
          )}
        </div>
      </div>
      <ScannerPickerDialog {...webConnectPickerProps} />
    </div>
  );
}

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel, hotelType: state.auth.hotelType };
}
export default connect(mapStateToProps)(GuestInformation);
